var items = {
  "block.minecraft.acacia_button": "Κουμπί Ακακίας",
  "block.minecraft.acacia_door": "Πόρτα Ακακίας",
  "block.minecraft.acacia_fence": "Φράχτης Ακακίας",
  "block.minecraft.acacia_fence_gate": "Πύλη Φράχτη Ακακίας",
  "block.minecraft.acacia_hanging_sign": "Κρεμαστή Πινακίδα Ακακίας",
  "block.minecraft.acacia_leaves": "Φύλλα Ακακίας",
  "block.minecraft.acacia_log": "Κορμός Ακακίας",
  "block.minecraft.acacia_planks": "Σανίδες Ακακίας",
  "block.minecraft.acacia_pressure_plate": "Πλάκα Πίεσης Ακακίας",
  "block.minecraft.acacia_sapling": "Βλαστάρι Ακακίας",
  "block.minecraft.acacia_shelf": "Ράφι Ακακίας",
  "block.minecraft.acacia_sign": "Πινακίδα Ακακίας",
  "block.minecraft.acacia_slab": "Πλάκα Ακακίας",
  "block.minecraft.acacia_stairs": "Σκάλες Ακακίας",
  "block.minecraft.acacia_trapdoor": "Καταπακτή Ακακίας",
  "block.minecraft.acacia_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Ακακίας",
  "block.minecraft.acacia_wall_sign": "Πινακίδα Τοίχου Ακακίας",
  "block.minecraft.acacia_wood": "Ξύλο Ακακίας",
  "block.minecraft.activator_rail": "Ράγα Ενεργοποίησης",
  "block.minecraft.air": "Αέρας",
  "block.minecraft.allium": "Άλλιο",
  "block.minecraft.amethyst_block": "Κύβος Αμέθυστου",
  "block.minecraft.amethyst_cluster": "Σύμπλεγμα Αμέθυστου",
  "block.minecraft.ancient_debris": "Αρχαία Συντρίμμια",
  "block.minecraft.andesite": "Ανδεσίτης",
  "block.minecraft.andesite_slab": "Πλάκα Ανδεσίτη",
  "block.minecraft.andesite_stairs": "Σκάλες Ανδεσίτη",
  "block.minecraft.andesite_wall": "Τοίχος Ανδεσίτη",
  "block.minecraft.anvil": "Αμόνι",
  "block.minecraft.attached_melon_stem": "Συνδεδεμένος Βλαστός Καρπουζιού",
  "block.minecraft.attached_pumpkin_stem": "Συνδεδεμένος Βλαστός Κολοκύθας",
  "block.minecraft.azalea": "Αζαλέα",
  "block.minecraft.azalea_leaves": "Φύλλα Αζαλέας",
  "block.minecraft.azure_bluet": "Αζουριά",
  "block.minecraft.bamboo": "Μπαμπού",
  "block.minecraft.bamboo_block": "Κύβος Μπαμπού",
  "block.minecraft.bamboo_button": "Κουμπί Μπαμπού",
  "block.minecraft.bamboo_door": "Πόρτα Μπαμπού",
  "block.minecraft.bamboo_fence": "Φράχτης Μπαμπού",
  "block.minecraft.bamboo_fence_gate": "Πύλη Φράχτη Μπαμπού",
  "block.minecraft.bamboo_hanging_sign": "Κρεμαστή Πινακίδα Μπαμπού",
  "block.minecraft.bamboo_mosaic": "Μωσαϊκό Μπαμπού",
  "block.minecraft.bamboo_mosaic_slab": "Πλάκα Μωσαϊκού Μπαμπού",
  "block.minecraft.bamboo_mosaic_stairs": "Σκάλες Μωσαϊκού Μπαμπού",
  "block.minecraft.bamboo_planks": "Σανίδες Μπαμπού",
  "block.minecraft.bamboo_pressure_plate": "Πλάκα Πίεσης Μπαμπού",
  "block.minecraft.bamboo_sapling": "Ρίζα Μπαμπού",
  "block.minecraft.bamboo_shelf": "Ράφι Μπαμπού",
  "block.minecraft.bamboo_sign": "Πινακίδα Μπαμπού",
  "block.minecraft.bamboo_slab": "Πλάκα Μπαμπού",
  "block.minecraft.bamboo_stairs": "Σκάλες Μπαμπού",
  "block.minecraft.bamboo_trapdoor": "Καταπακτή Μπαμπού",
  "block.minecraft.bamboo_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Μπαμπού",
  "block.minecraft.bamboo_wall_sign": "Πινακίδα Τοίχου Μπαμπού",
  "block.minecraft.banner.base.black": "Πλήρως Μαύρο Φόντο",
  "block.minecraft.banner.base.blue": "Πλήρως Μπλε Φόντο",
  "block.minecraft.banner.base.brown": "Πλήρως Καφέ Φόντο",
  "block.minecraft.banner.base.cyan": "Πλήρως Κυανό Φόντο",
  "block.minecraft.banner.base.gray": "Πλήρως Γκρίζο Φόντο",
  "block.minecraft.banner.base.green": "Πλήρως Πράσινο Φόντο",
  "block.minecraft.banner.base.light_blue": "Πλήρως Γαλάζιο Φόντο",
  "block.minecraft.banner.base.light_gray": "Πλήρως Ανοιχτό Γκρίζο Φόντο",
  "block.minecraft.banner.base.lime": "Πλήρως Λαχανί Φόντο",
  "block.minecraft.banner.base.magenta": "Πλήρως Φούξια Φόντο",
  "block.minecraft.banner.base.orange": "Πλήρως Πορτοκαλί Φόντο",
  "block.minecraft.banner.base.pink": "Πλήρως Ροζ Φόντο",
  "block.minecraft.banner.base.purple": "Πλήρως Μοβ Φόντο",
  "block.minecraft.banner.base.red": "Πλήρως Κόκκινο Φόντο",
  "block.minecraft.banner.base.white": "Πλήρως Λευκό Φόντο",
  "block.minecraft.banner.base.yellow": "Πλήρως Κίτρινο Φόντο",
  "block.minecraft.banner.border.black": "Μαύρη Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.blue": "Μπλε Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.brown": "Καφέ Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.cyan": "Κυανή Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.gray": "Γκρίζα Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.green": "Πράσινη Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.light_blue": "Γαλάζια Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.light_gray": "Ανοιχτή Γκρίζα Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.lime": "Λαχανί Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.magenta": "Φούξια Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.orange": "Πορτοκαλί Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.pink": "Ροζ Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.purple": "Μοβ Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.red": "Κόκκινη Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.white": "Λευκή Περιμετρική Λωρίδα",
  "block.minecraft.banner.border.yellow": "Κίτρινη Περιμετρική Λωρίδα",
  "block.minecraft.banner.bricks.black": "Μαύρο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.blue": "Μπλε Φόντο Τούβλων",
  "block.minecraft.banner.bricks.brown": "Καφέ Φόντο Τούβλων",
  "block.minecraft.banner.bricks.cyan": "Κυανό Φόντο Τούβλων",
  "block.minecraft.banner.bricks.gray": "Γκρίζο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.green": "Πράσινο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.light_blue": "Γαλάζιο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.light_gray": "Ανοιχτό Γκρίζο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.lime": "Λαχανί Φόντο Τούβλων",
  "block.minecraft.banner.bricks.magenta": "Φούξια Φόντο Τούβλων",
  "block.minecraft.banner.bricks.orange": "Πορτοκαλί Φόντο Τούβλων",
  "block.minecraft.banner.bricks.pink": "Ροζ Φόντο Τούβλων",
  "block.minecraft.banner.bricks.purple": "Μοβ Φόντο Τούβλων",
  "block.minecraft.banner.bricks.red": "Κόκκινο Φόντο Τούβλων",
  "block.minecraft.banner.bricks.white": "Λευκό Φόντο Τούβλων",
  "block.minecraft.banner.bricks.yellow": "Κίτρινο Φόντο Τούβλων",
  "block.minecraft.banner.circle.black": "Μαύρος Κύκλος",
  "block.minecraft.banner.circle.blue": "Μπλε Κύκλος",
  "block.minecraft.banner.circle.brown": "Καφέ Κύκλος",
  "block.minecraft.banner.circle.cyan": "Κυανός Κύκλος",
  "block.minecraft.banner.circle.gray": "Γκρίζος Κύκλος",
  "block.minecraft.banner.circle.green": "Πράσινος Κύκλος",
  "block.minecraft.banner.circle.light_blue": "Γαλάζιος Κύκλος",
  "block.minecraft.banner.circle.light_gray": "Ανοιχτός Γκρίζος Κύκλος",
  "block.minecraft.banner.circle.lime": "Λαχανί Κύκλος",
  "block.minecraft.banner.circle.magenta": "Φούξια Κύκλος",
  "block.minecraft.banner.circle.orange": "Πορτοκαλί Κύκλος",
  "block.minecraft.banner.circle.pink": "Ροζ Κύκλος",
  "block.minecraft.banner.circle.purple": "Μοβ Κύκλος",
  "block.minecraft.banner.circle.red": "Κόκκινος Κύκλος",
  "block.minecraft.banner.circle.white": "Λευκός Κύκλος",
  "block.minecraft.banner.circle.yellow": "Κίτρινος Κύκλος",
  "block.minecraft.banner.creeper.black": "Μαύρο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.blue": "Μπλε Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.brown": "Καφέ Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.cyan": "Κυανό Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.gray": "Γκρίζο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.green": "Πράσινο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.light_blue": "Γαλάζιο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.light_gray": "Ανοιχτό Γκρίζο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.lime": "Λαχανί Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.magenta": "Φούξια Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.orange": "Πορτοκαλί Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.pink": "Ροζ Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.purple": "Μοβ Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.red": "Κόκκινο Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.white": "Λευκό Σήμα Κρίπερ",
  "block.minecraft.banner.creeper.yellow": "Κίτρινο Σήμα Κρίπερ",
  "block.minecraft.banner.cross.black": "Μαύρος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.blue": "Μπλε Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.brown": "Καφέ Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.cyan": "Κυανός Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.gray": "Γκρίζος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.green": "Πράσινος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.light_blue": "Γαλάζιος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.light_gray": "Ανοιχτός Γκρίζος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.lime": "Λαχανί Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.magenta": "Φούξια Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.orange": "Πορτοκαλί Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.pink": "Ροζ Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.purple": "Μοβ Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.red": "Κόκκινος Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.white": "Λευκός Διαγώνιος Σταυρός",
  "block.minecraft.banner.cross.yellow": "Κίτρινος Διαγώνιος Σταυρός",
  "block.minecraft.banner.curly_border.black": "Μαύρη Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.blue": "Μπλε Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.brown": "Καφέ Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.cyan": "Κυανή Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.gray": "Γκρίζα Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.green": "Πράσινη Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.light_blue": "Γαλάζια Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.light_gray": "Ανοιχτή Γκρίζα Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.lime": "Λαχανί Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.magenta": "Φούξια Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.orange": "Πορτοκαλί Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.pink": "Ροζ Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.purple": "Μοβ Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.red": "Κόκκινη Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.white": "Λευκή Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.curly_border.yellow": "Κίτρινη Οδοντωτή Περιμετρική Λωρίδα",
  "block.minecraft.banner.diagonal_left.black": "Μαύρο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.blue": "Μπλε Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.brown": "Καφέ Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.cyan": "Κυανό Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.gray": "Γκρίζο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.green": "Πράσινο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.light_blue": "Γαλάζιο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.light_gray": "Ανοιχτό Γκρίζο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.lime": "Λαχανί Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.magenta": "Φούξια Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.orange": "Πορτοκαλί Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.pink": "Ροζ Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.purple": "Μοβ Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.red": "Κόκκινο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.white": "Λευκό Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_left.yellow": "Κίτρινο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.black": "Μαύρο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.blue": "Μπλε Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.brown": "Καφέ Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.cyan": "Κυανό Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.gray": "Γκρίζο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.green": "Πράσινο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.light_blue": "Γαλάζιο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.light_gray": "Ανοιχτό Γκρίζο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.lime": "Λαχανί Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.magenta": "Φούξια Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.orange": "Πορτοκαλί Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.pink": "Ροζ Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.purple": "Μοβ Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.red": "Κόκκινο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.white": "Λευκό Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_right.yellow": "Κίτρινο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.black": "Μαύρο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.blue": "Μπλε Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.brown": "Καφέ Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.cyan": "Κυανό Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.gray": "Γκρίζο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.green": "Πράσινο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Γαλάζιο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ανοιχτό Γκρίζο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.lime": "Λαχανί Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.magenta": "Φούξια Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.orange": "Πορτοκαλί Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.pink": "Ροζ Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.purple": "Μοβ Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.red": "Κόκκινο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.white": "Λευκό Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_left.yellow": "Κίτρινο Ανεστραμμένο Αριστερό Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.black": "Μαύρο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.blue": "Μπλε Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.brown": "Καφέ Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.cyan": "Κυανό Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.gray": "Γκρίζο Δεξί Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.green": "Πράσινο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Γαλάζιο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ανοιχτό Γκρίζο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.lime": "Λαχανί Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.magenta": "Φούξια Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.orange": "Πορτοκαλί Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.pink": "Ροζ Δεξί Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.purple": "Μοβ Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.red": "Κόκκινο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.white": "Λευκό Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.diagonal_up_right.yellow": "Κίτρινο Ανεστραμμένο Δεξί Διαγώνιο Μισό Τμήμα",
  "block.minecraft.banner.flow.black": "Μαύρη Ροή",
  "block.minecraft.banner.flow.blue": "Μπλε Ροή",
  "block.minecraft.banner.flow.brown": "Καφέ Ροή",
  "block.minecraft.banner.flow.cyan": "Κυανή Ροή",
  "block.minecraft.banner.flow.gray": "Γκρίζα Ροή",
  "block.minecraft.banner.flow.green": "Πράσινη Ροή",
  "block.minecraft.banner.flow.light_blue": "Γαλάζια Ροή",
  "block.minecraft.banner.flow.light_gray": "Ανοιχτή Γκρίζα Ροή",
  "block.minecraft.banner.flow.lime": "Λαχανί Ροή",
  "block.minecraft.banner.flow.magenta": "Φούξια Ροή",
  "block.minecraft.banner.flow.orange": "Πορτοκαλί Ροή",
  "block.minecraft.banner.flow.pink": "Ροζ Ροή",
  "block.minecraft.banner.flow.purple": "Μοβ Ροή",
  "block.minecraft.banner.flow.red": "Κόκκινη Ροή",
  "block.minecraft.banner.flow.white": "Λευκή Ροή",
  "block.minecraft.banner.flow.yellow": "Κίτρινη Ροή",
  "block.minecraft.banner.flower.black": "Μαύρο Σήμα Άνθους",
  "block.minecraft.banner.flower.blue": "Μπλε Σήμα Άνθους",
  "block.minecraft.banner.flower.brown": "Καφέ Σήμα Άνθους",
  "block.minecraft.banner.flower.cyan": "Κυανό Σήμα Άνθους",
  "block.minecraft.banner.flower.gray": "Γκρίζο Σήμα Άνθους",
  "block.minecraft.banner.flower.green": "Πράσινο Σήμα Άνθους",
  "block.minecraft.banner.flower.light_blue": "Γαλάζιο Σήμα Άνθους",
  "block.minecraft.banner.flower.light_gray": "Ανοιχτό Γκρίζο Σήμα Άνθους",
  "block.minecraft.banner.flower.lime": "Λαχανί Σήμα Άνθους",
  "block.minecraft.banner.flower.magenta": "Φούξια Σήμα Άνθους",
  "block.minecraft.banner.flower.orange": "Πορτοκαλί Σήμα Άνθους",
  "block.minecraft.banner.flower.pink": "Ροζ Σήμα Άνθους",
  "block.minecraft.banner.flower.purple": "Μοβ Σήμα Άνθους",
  "block.minecraft.banner.flower.red": "Κόκκινο Σήμα Άνθους",
  "block.minecraft.banner.flower.white": "Λευκό Σήμα Άνθους",
  "block.minecraft.banner.flower.yellow": "Κίτρινο Σήμα Άνθους",
  "block.minecraft.banner.globe.black": "Μαύρη Υδρόγειος",
  "block.minecraft.banner.globe.blue": "Μπλε Υδρόγειος",
  "block.minecraft.banner.globe.brown": "Καφέ Υδρόγειος",
  "block.minecraft.banner.globe.cyan": "Κυανή Υδρόγειος",
  "block.minecraft.banner.globe.gray": "Γκρίζα Υδρόγειος",
  "block.minecraft.banner.globe.green": "Πράσινη Υδρόγειος",
  "block.minecraft.banner.globe.light_blue": "Γαλάζια Υδρόγειος",
  "block.minecraft.banner.globe.light_gray": "Ανοιχτή Γκρίζα Υδρόγειος",
  "block.minecraft.banner.globe.lime": "Λαχανί Υδρόγειος",
  "block.minecraft.banner.globe.magenta": "Μοβ Υδρόγειος",
  "block.minecraft.banner.globe.orange": "Πορτοκαλί Υδρόγειος",
  "block.minecraft.banner.globe.pink": "Ροζ Υδρόγειος",
  "block.minecraft.banner.globe.purple": "Μοβ Υδρόγειος",
  "block.minecraft.banner.globe.red": "Κόκκινη Υδρόγειος",
  "block.minecraft.banner.globe.white": "Λευκή Υδρόγειος",
  "block.minecraft.banner.globe.yellow": "Κίτρινη Υδρόγειος",
  "block.minecraft.banner.gradient.black": "Μαύρη Βαθμίδα",
  "block.minecraft.banner.gradient.blue": "Μπλε Βαθμίδα",
  "block.minecraft.banner.gradient.brown": "Καφέ Βαθμίδα",
  "block.minecraft.banner.gradient.cyan": "Κυανή Βαθμίδα",
  "block.minecraft.banner.gradient.gray": "Γκρίζα Βαθμίδα",
  "block.minecraft.banner.gradient.green": "Πράσινη Βαθμίδα",
  "block.minecraft.banner.gradient.light_blue": "Γαλάζια Βαθμίδα",
  "block.minecraft.banner.gradient.light_gray": "Ανοιχτή Γκρίζα Βαθμίδα",
  "block.minecraft.banner.gradient.lime": "Λαχανί Βαθμίδα",
  "block.minecraft.banner.gradient.magenta": "Φούξια Βαθμίδα",
  "block.minecraft.banner.gradient.orange": "Πορτοκαλί Βαθμίδα",
  "block.minecraft.banner.gradient.pink": "Ροζ Βαθμίδα",
  "block.minecraft.banner.gradient.purple": "Μοβ Βαθμίδα",
  "block.minecraft.banner.gradient.red": "Κόκκινη Βαθμίδα",
  "block.minecraft.banner.gradient.white": "Λευκή Βαθμίδα",
  "block.minecraft.banner.gradient.yellow": "Κίτρινη Βαθμίδα",
  "block.minecraft.banner.gradient_up.black": "Μαύρη Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.blue": "Μπλε Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.brown": "Καφέ Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.cyan": "Κυανή Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.gray": "Γκρίζα Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.green": "Πράσινη Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.light_blue": "Γαλάζια Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.light_gray": "Ανοιχτή Γκρίζα Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.lime": "Λαχανί Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.magenta": "Φούξια Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.orange": "Πορτοκαλί Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.pink": "Ροζ Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.purple": "Μοβ Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.red": "Κόκκινη Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.white": "Λευκή Βαθμίδα Βάσης",
  "block.minecraft.banner.gradient_up.yellow": "Κίτρινη Βαθμίδα Βάσης",
  "block.minecraft.banner.guster.black": "Μαύρη Ριπή",
  "block.minecraft.banner.guster.blue": "Μπλε Ριπή",
  "block.minecraft.banner.guster.brown": "Καφέ Ριπή",
  "block.minecraft.banner.guster.cyan": "Κυανή Ριπή",
  "block.minecraft.banner.guster.gray": "Γκρίζα Ριπή",
  "block.minecraft.banner.guster.green": "Πράσινη Ριπή",
  "block.minecraft.banner.guster.light_blue": "Γαλάζια Ριπή",
  "block.minecraft.banner.guster.light_gray": "Ανοιχτή Γκρίζα Ριπή",
  "block.minecraft.banner.guster.lime": "Λαχανί Ριπή",
  "block.minecraft.banner.guster.magenta": "Φούξια Ριπή",
  "block.minecraft.banner.guster.orange": "Πορτοκαλί Ριπή",
  "block.minecraft.banner.guster.pink": "Ροζ Ριπή",
  "block.minecraft.banner.guster.purple": "Μοβ Ριπή",
  "block.minecraft.banner.guster.red": "Κόκκινη Ριπή",
  "block.minecraft.banner.guster.white": "Λευκή Ριπή",
  "block.minecraft.banner.guster.yellow": "Κίτρινη Ριπή",
  "block.minecraft.banner.half_horizontal.black": "Μαύρο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.blue": "Μπλε Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.brown": "Καφέ Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.cyan": "Κυανό Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.gray": "Γκρίζο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.green": "Πράσινο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.light_blue": "Γαλάζιο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.light_gray": "Ανοιχτό Γκρίζο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.lime": "Λαχανί Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.magenta": "Φούξια Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.orange": "Πορτοκαλί Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.pink": "Ροζ Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.purple": "Μοβ Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.red": "Κόκκινο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.white": "Λευκό Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal.yellow": "Κίτρινο Οριζόντιο Μισό Τμήμα Κορυφής",
  "block.minecraft.banner.half_horizontal_bottom.black": "Μαύρο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Μπλε Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Καφέ Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Κυανό Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Γκρίζο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.green": "Πράσινο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Γαλάζιο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ανοιχτό Γκρίζο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Λαχανί Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Φούξια Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Πορτοκαλί Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ροζ Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Μοβ Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.red": "Κόκκινο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.white": "Λευκό Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Κίτρινο Οριζόντιο Μισό Τμήμα Βάσης",
  "block.minecraft.banner.half_vertical.black": "Μαύρο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.blue": "Μπλε Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.brown": "Καφέ Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.cyan": "Κυανό Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.gray": "Γκρίζο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.green": "Πράσινο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.light_blue": "Γαλάζιο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.light_gray": "Ανοιχτό Γκρίζο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.lime": "Λαχανί Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.magenta": "Φούξια Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.orange": "Πορτοκαλί Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.pink": "Ροζ Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.purple": "Μοβ Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.red": "Κόκκινο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.white": "Λευκό Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical.yellow": "Κίτρινο Κάθετο Δεξί Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.black": "Μαύρο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.blue": "Μπλε Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.brown": "Καφέ Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.cyan": "Κυανό Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.gray": "Γκρίζο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.green": "Πράσινο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.light_blue": "Γαλάζιο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ανοιχτό Γκρίζο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.lime": "Λαχανί Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.magenta": "Φούξια Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.orange": "Πορτοκαλί Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.pink": "Ροζ Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.purple": "Μοβ Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.red": "Κόκκινο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.white": "Λευκό Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.half_vertical_right.yellow": "Κίτρινο Κάθετο Αριστερό Μισό Τμήμα",
  "block.minecraft.banner.mojang.black": "Μαύρο Πράγμα",
  "block.minecraft.banner.mojang.blue": "Μπλε Πράγμα",
  "block.minecraft.banner.mojang.brown": "Καφέ Πράγμα",
  "block.minecraft.banner.mojang.cyan": "Κυανό Πράγμα",
  "block.minecraft.banner.mojang.gray": "Γκρίζο Πράγμα",
  "block.minecraft.banner.mojang.green": "Πράσινο Πράγμα",
  "block.minecraft.banner.mojang.light_blue": "Γαλάζιο Πράγμα",
  "block.minecraft.banner.mojang.light_gray": "Ανοιχτό Γκρίζο Πράγμα",
  "block.minecraft.banner.mojang.lime": "Λαχανί Πράγμα",
  "block.minecraft.banner.mojang.magenta": "Φούξια Πράγμα",
  "block.minecraft.banner.mojang.orange": "Πορτοκαλί Πράγμα",
  "block.minecraft.banner.mojang.pink": "Ροζ Πράγμα",
  "block.minecraft.banner.mojang.purple": "Μοβ Πράγμα",
  "block.minecraft.banner.mojang.red": "Κόκκινο Πράγμα",
  "block.minecraft.banner.mojang.white": "Λευκό Πράγμα",
  "block.minecraft.banner.mojang.yellow": "Κίτρινο Πράγμα",
  "block.minecraft.banner.piglin.black": "Μαύρη Μουσούδα",
  "block.minecraft.banner.piglin.blue": "Μπλε Μουσούδα",
  "block.minecraft.banner.piglin.brown": "Καφέ Μουσούδα",
  "block.minecraft.banner.piglin.cyan": "Κυανή Μουσούδα",
  "block.minecraft.banner.piglin.gray": "Γκρίζα Μουσούδα",
  "block.minecraft.banner.piglin.green": "Πράσινη Μουσούδα",
  "block.minecraft.banner.piglin.light_blue": "Γαλάζια Μουσούδα",
  "block.minecraft.banner.piglin.light_gray": "Ανοιχτή Γκρίζα Μουσούδα",
  "block.minecraft.banner.piglin.lime": "Λαχανί Μουσούδα",
  "block.minecraft.banner.piglin.magenta": "Φούξια Μουσούδα",
  "block.minecraft.banner.piglin.orange": "Πορτοκαλί Μουσούδα",
  "block.minecraft.banner.piglin.pink": "Ροζ Μουσούδα",
  "block.minecraft.banner.piglin.purple": "Μοβ Μουσούδα",
  "block.minecraft.banner.piglin.red": "Κόκκινη Μουσούδα",
  "block.minecraft.banner.piglin.white": "Λευκή Μουσούδα",
  "block.minecraft.banner.piglin.yellow": "Κίτρινη Μουσούδα",
  "block.minecraft.banner.rhombus.black": "Μαύρος Ρόμβος",
  "block.minecraft.banner.rhombus.blue": "Μπλε Ρόμβος",
  "block.minecraft.banner.rhombus.brown": "Καφέ Ρόμβος",
  "block.minecraft.banner.rhombus.cyan": "Κυανός Ρόμβος",
  "block.minecraft.banner.rhombus.gray": "Γκρίζος Ρόμβος",
  "block.minecraft.banner.rhombus.green": "Πράσινος Ρόμβος",
  "block.minecraft.banner.rhombus.light_blue": "Γαλάζιος Ρόμβος",
  "block.minecraft.banner.rhombus.light_gray": "Ανοιχτός Γκρίζος Ρόμβος",
  "block.minecraft.banner.rhombus.lime": "Λαχανί Ρόμβος",
  "block.minecraft.banner.rhombus.magenta": "Φούξια Ρόμβος",
  "block.minecraft.banner.rhombus.orange": "Πορτοκαλί Ρόμβος",
  "block.minecraft.banner.rhombus.pink": "Ροζ Ρόμβος",
  "block.minecraft.banner.rhombus.purple": "Μοβ Ρόμβος",
  "block.minecraft.banner.rhombus.red": "Κόκκινος Ρόμβος",
  "block.minecraft.banner.rhombus.white": "Λευκός Ρόμβος",
  "block.minecraft.banner.rhombus.yellow": "Κίτρινος Ρόμβος",
  "block.minecraft.banner.skull.black": "Μαύρο Σήμα Κρανίου",
  "block.minecraft.banner.skull.blue": "Μπλε Σήμα Κρανίου",
  "block.minecraft.banner.skull.brown": "Καφέ Σήμα Κρανίου",
  "block.minecraft.banner.skull.cyan": "Κυανό Σήμα Κρανίου",
  "block.minecraft.banner.skull.gray": "Γκρίζο Σήμα Κρανίου",
  "block.minecraft.banner.skull.green": "Πράσινο Σήμα Κρανίου",
  "block.minecraft.banner.skull.light_blue": "Γαλάζιο Σήμα Κρανίου",
  "block.minecraft.banner.skull.light_gray": "Ανοιχτό Γκρίζο Σήμα Κρανίου",
  "block.minecraft.banner.skull.lime": "Λαχανί Σήμα Κρανίου",
  "block.minecraft.banner.skull.magenta": "Φούξια Σήμα Κρανίου",
  "block.minecraft.banner.skull.orange": "Πορτοκαλί Σήμα Κρανίου",
  "block.minecraft.banner.skull.pink": "Ροζ Σήμα Κρανίου",
  "block.minecraft.banner.skull.purple": "Μοβ Σήμα Κρανίου",
  "block.minecraft.banner.skull.red": "Κόκκινο Σήμα Κρανίου",
  "block.minecraft.banner.skull.white": "Λευκό Σήμα Κρανίου",
  "block.minecraft.banner.skull.yellow": "Κίτρινο Σήμα Κρανίου",
  "block.minecraft.banner.small_stripes.black": "Μαύρες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.blue": "Μπλε Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.brown": "Καφέ Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.cyan": "Κυανές Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.gray": "Γκρίζες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.green": "Πράσινες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.light_blue": "Γαλάζιες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.light_gray": "Ανοιχτές Γκρίζες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.lime": "Λαχανί Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.magenta": "Φούξια Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.orange": "Πορτοκαλί Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.pink": "Ροζ Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.purple": "Μοβ Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.red": "Κόκκινες Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.white": "Λευκές Κάθετες Λωρίδες",
  "block.minecraft.banner.small_stripes.yellow": "Κίτρινες Κάθετες Λωρίδες",
  "block.minecraft.banner.square_bottom_left.black": "Μαύρο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.blue": "Μπλε Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.brown": "Καφέ Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.cyan": "Κυανό Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.gray": "Γκρίζο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.green": "Πράσινο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.light_blue": "Γαλάζιο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ανοιχτό Γκρίζο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.lime": "Λαχανί Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.magenta": "Φούξια Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.orange": "Πορτοκαλί Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.pink": "Ροζ Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.purple": "Μοβ Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.red": "Κόκκινο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.white": "Λευκό Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_left.yellow": "Κίτρινο Δεξί Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.black": "Μαύρο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.blue": "Μπλε Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.brown": "Καφέ Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.cyan": "Κυανό Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.gray": "Γκρίζο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.green": "Πράσινο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.light_blue": "Γαλάζιο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ανοιχτό Γκρίζο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.lime": "Λαχανί Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.magenta": "Φούξια Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.orange": "Πορτοκαλί Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.pink": "Ροζ Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.purple": "Μοβ Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.red": "Κόκκινο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.white": "Λευκό Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_bottom_right.yellow": "Κίτρινο Αριστερό Καντόνι Βάσης",
  "block.minecraft.banner.square_top_left.black": "Μαύρο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.blue": "Μπλε Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.brown": "Καφέ Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.cyan": "Κυανό Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.gray": "Γκρίζο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.green": "Πράσινο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.light_blue": "Γαλάζιο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.light_gray": "Ανοιχτό Γκρίζο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.lime": "Λαχανί Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.magenta": "Φούξια Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.orange": "Πορτοκαλί Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.pink": "Ροζ Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.purple": "Μοβ Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.red": "Κόκκινο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.white": "Λευκό Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_left.yellow": "Κίτρινο Δεξί Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.black": "Μαύρο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.blue": "Μπλε Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.brown": "Καφέ Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.cyan": "Κυανό Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.gray": "Γκρίζο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.green": "Πράσινο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.light_blue": "Γαλάζιο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.light_gray": "Ανοιχτό Γκρίζο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.lime": "Λαχανί Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.magenta": "Φούξια Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.orange": "Πορτοκαλί Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.pink": "Ροζ Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.purple": "Μοβ Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.red": "Κόκκινο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.white": "Λευκό Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.square_top_right.yellow": "Κίτρινο Αριστερό Καντόνι Κορυφής",
  "block.minecraft.banner.straight_cross.black": "Μαύρος Σταυρός",
  "block.minecraft.banner.straight_cross.blue": "Μπλε Σταυρός",
  "block.minecraft.banner.straight_cross.brown": "Καφέ Σταυρός",
  "block.minecraft.banner.straight_cross.cyan": "Κυανός Σταυρός",
  "block.minecraft.banner.straight_cross.gray": "Γκρίζος Σταυρός",
  "block.minecraft.banner.straight_cross.green": "Πράσινος Σταυρός",
  "block.minecraft.banner.straight_cross.light_blue": "Γαλάζιος Σταυρός",
  "block.minecraft.banner.straight_cross.light_gray": "Ανοιχτός Γκρίζος Σταυρός",
  "block.minecraft.banner.straight_cross.lime": "Λαχανί Σταυρός",
  "block.minecraft.banner.straight_cross.magenta": "Φούξια Σταυρός",
  "block.minecraft.banner.straight_cross.orange": "Πορτοκαλί Σταυρός",
  "block.minecraft.banner.straight_cross.pink": "Ροζ Σταυρός",
  "block.minecraft.banner.straight_cross.purple": "Μοβ Σταυρός",
  "block.minecraft.banner.straight_cross.red": "Κόκκινος Σταυρός",
  "block.minecraft.banner.straight_cross.white": "Λευκός Σταυρός",
  "block.minecraft.banner.straight_cross.yellow": "Κίτρινος Σταυρός",
  "block.minecraft.banner.stripe_bottom.black": "Μαύρη Βάση",
  "block.minecraft.banner.stripe_bottom.blue": "Μπλε Βάση",
  "block.minecraft.banner.stripe_bottom.brown": "Καφέ Βάση",
  "block.minecraft.banner.stripe_bottom.cyan": "Κυανή Βάση",
  "block.minecraft.banner.stripe_bottom.gray": "Γκρίζα Βάση",
  "block.minecraft.banner.stripe_bottom.green": "Πράσινη Βάση",
  "block.minecraft.banner.stripe_bottom.light_blue": "Γαλάζια Βάση",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ανοιχτή Γκρίζα Βάση",
  "block.minecraft.banner.stripe_bottom.lime": "Λαχανί Βάση",
  "block.minecraft.banner.stripe_bottom.magenta": "Φούξια Βάση",
  "block.minecraft.banner.stripe_bottom.orange": "Πορτοκαλί Βάση",
  "block.minecraft.banner.stripe_bottom.pink": "Ροζ Βάση",
  "block.minecraft.banner.stripe_bottom.purple": "Μοβ Βάση",
  "block.minecraft.banner.stripe_bottom.red": "Κόκκινη Βάση",
  "block.minecraft.banner.stripe_bottom.white": "Λευκή Βάση",
  "block.minecraft.banner.stripe_bottom.yellow": "Κίτρινη Βάση",
  "block.minecraft.banner.stripe_center.black": "Μαύρη Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.blue": "Μπλε Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.brown": "Καφέ Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.cyan": "Κυανή Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.gray": "Γκρίζα Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.green": "Πράσινη Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.light_blue": "Γαλάζια Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.light_gray": "Ανοιχτή Γκρίζα Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.lime": "Λαχανί Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.magenta": "Φούξια Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.orange": "Πορτοκαλί Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.pink": "Ροζ Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.purple": "Μοβ Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.red": "Κόκκινη Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.white": "Λευκή Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_center.yellow": "Κίτρινη Κάθετη Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_downleft.black": "Μαύρη Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.blue": "Μπλε Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.brown": "Καφέ Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.cyan": "Κυανή Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.gray": "Γκρίζα Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.green": "Πράσινη Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.light_blue": "Γαλάζια Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ανοιχτή Γκρίζα Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.lime": "Λαχανί Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.magenta": "Φούξια Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.orange": "Πορτοκαλί Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.pink": "Ροζ Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.purple": "Μοβ Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.red": "Κόκκινη Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.white": "Λευκή Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downleft.yellow": "Κίτρινη Αριστερή Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.black": "Μαύρη Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.blue": "Μπλε Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.brown": "Καφέ Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.cyan": "Κυανή Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.gray": "Γκρίζα Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.green": "Πράσινη Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.light_blue": "Γαλάζια Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.light_gray": "Ανοιχτή Γκρίζα Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.lime": "Λαχανί Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.magenta": "Φούξια Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.orange": "Πορτοκαλί Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.pink": "Ροζ Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.purple": "Μοβ Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.red": "Κόκκινη Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.white": "Λευκή Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_downright.yellow": "Κίτρινη Δεξιά Διαγώνια Λωρίδα",
  "block.minecraft.banner.stripe_left.black": "Μαύρη Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.blue": "Μπλε Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.brown": "Καφέ Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.cyan": "Κυανή Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.gray": "Γκρίζα Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.green": "Πράσινη Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.light_blue": "Γαλάζια Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.light_gray": "Ανοιχτή Γκρίζα Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.lime": "Λαχανί Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.magenta": "Φούξια Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.orange": "Πορτοκαλί Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.pink": "Ροζ Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.purple": "Μοβ Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.red": "Κόκκινη Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.white": "Λευκή Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_left.yellow": "Κίτρινη Δεξιά Λωρίδα",
  "block.minecraft.banner.stripe_middle.black": "Μαύρη Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.blue": "Μπλε Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.brown": "Καφέ Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.cyan": "Κυανή Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.gray": "Γκρίζα Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.green": "Πράσινη Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.light_blue": "Γαλάζια Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.light_gray": "Ανοιχτή Γκρίζα Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.lime": "Λαχανί Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.magenta": "Φούξια Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.orange": "Πορτοκαλί Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.pink": "Ροζ Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.purple": "Μοβ Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.red": "Κόκκινη Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.white": "Λευκή Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_middle.yellow": "Κίτρινη Οριζόντια Μεσαία Λωρίδα",
  "block.minecraft.banner.stripe_right.black": "Μαύρη Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.blue": "Μπλε Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.brown": "Καφέ Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.cyan": "Κυανή Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.gray": "Γκρίζα Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.green": "Πράσινη Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.light_blue": "Γαλάζια Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.light_gray": "Ανοιχτή Γκρίζα Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.lime": "Λαχανί Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.magenta": "Φούξια Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.orange": "Πορτοκαλί Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.pink": "Ροζ Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.purple": "Μοβ Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.red": "Κόκκινη Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.white": "Λευκή Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_right.yellow": "Κίτρινη Αριστερή Λωρίδα",
  "block.minecraft.banner.stripe_top.black": "Μαύρη Κορυφή",
  "block.minecraft.banner.stripe_top.blue": "Μπλε Κορυφή",
  "block.minecraft.banner.stripe_top.brown": "Καφέ Κορυφή",
  "block.minecraft.banner.stripe_top.cyan": "Κυανή Κορυφή",
  "block.minecraft.banner.stripe_top.gray": "Γκρίζα Κορυφή",
  "block.minecraft.banner.stripe_top.green": "Πράσινη Κορυφή",
  "block.minecraft.banner.stripe_top.light_blue": "Γαλάζια Κορυφή",
  "block.minecraft.banner.stripe_top.light_gray": "Ανοιχτή Γκρίζα Κορυφή",
  "block.minecraft.banner.stripe_top.lime": "Λαχανί Κορυφή",
  "block.minecraft.banner.stripe_top.magenta": "Φούξια Κορυφή",
  "block.minecraft.banner.stripe_top.orange": "Πορτοκαλί Κορυφή",
  "block.minecraft.banner.stripe_top.pink": "Ροζ Κορυφή",
  "block.minecraft.banner.stripe_top.purple": "Μοβ Κορυφή",
  "block.minecraft.banner.stripe_top.red": "Κόκκινη Κορυφή",
  "block.minecraft.banner.stripe_top.white": "Λευκή Κορυφή",
  "block.minecraft.banner.stripe_top.yellow": "Κίτρινη Κορυφή",
  "block.minecraft.banner.triangle_bottom.black": "Μαύρο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.blue": "Μπλε Σιρίτι",
  "block.minecraft.banner.triangle_bottom.brown": "Καφέ Σιρίτι",
  "block.minecraft.banner.triangle_bottom.cyan": "Κυανό Σιρίτι",
  "block.minecraft.banner.triangle_bottom.gray": "Γκρίζο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.green": "Πράσινο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.light_blue": "Γαλάζιο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ανοιχτό Γκρίζο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.lime": "Λαχανί Σιρίτι",
  "block.minecraft.banner.triangle_bottom.magenta": "Φούξια Σιρίτι",
  "block.minecraft.banner.triangle_bottom.orange": "Πορτοκαλί Σιρίτι",
  "block.minecraft.banner.triangle_bottom.pink": "Ροζ Σιρίτι",
  "block.minecraft.banner.triangle_bottom.purple": "Μοβ Σιρίτι",
  "block.minecraft.banner.triangle_bottom.red": "Κόκκινο Σιρίτι",
  "block.minecraft.banner.triangle_bottom.white": "Λευκό Σιρίτι",
  "block.minecraft.banner.triangle_bottom.yellow": "Κίτρινο Σιρίτι",
  "block.minecraft.banner.triangle_top.black": "Μαύρο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.blue": "Μπλε Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.brown": "Καφέ Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.cyan": "Κυανό Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.gray": "Γκρίζο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.green": "Πράσινο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.light_blue": "Γαλάζιο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.light_gray": "Ανοιχτό Γκρίζο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.lime": "Λαχανί Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.magenta": "Φούξια Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.orange": "Πορτοκαλί Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.pink": "Ροζ Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.purple": "Μοβ Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.red": "Κόκκινο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.white": "Λευκό Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangle_top.yellow": "Κίτρινο Ανεστραμμένο Σιρίτι",
  "block.minecraft.banner.triangles_bottom.black": "Μαύρη Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.blue": "Μπλε Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.brown": "Καφέ Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.cyan": "Κυανή Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.gray": "Γκρίζα Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.green": "Πράσινη Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.light_blue": "Γαλάζια Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ανοιχτή Γκρίζα Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.lime": "Λαχανί Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.magenta": "Φούξια Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.orange": "Πορτοκαλί Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.pink": "Ροζ Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.purple": "Μοβ Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.red": "Κόκκινη Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.white": "Λευκή Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_bottom.yellow": "Κίτρινη Οδοντωτή Βάση",
  "block.minecraft.banner.triangles_top.black": "Μαύρη Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.blue": "Μπλε Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.brown": "Καφέ Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.cyan": "Κυανή Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.gray": "Γκρίζα Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.green": "Πράσινη Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.light_blue": "Γαλάζια Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.light_gray": "Ανοιχτή Γκρίζα Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.lime": "Λαχανί Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.magenta": "Φούξια Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.orange": "Πορτοκαλί Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.pink": "Ροζ Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.purple": "Μοβ Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.red": "Κόκκινη Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.white": "Λευκή Οδοντωτή Κορυφή",
  "block.minecraft.banner.triangles_top.yellow": "Κίτρινη Οδοντωτή Κορυφή",
  "block.minecraft.barrel": "Βαρέλι",
  "block.minecraft.barrier": "Φράγμα",
  "block.minecraft.basalt": "Βασάλτης",
  "block.minecraft.beacon": "Φάρος",
  "block.minecraft.beacon.primary": "Πρώτη Δύναμη",
  "block.minecraft.beacon.secondary": "Δεύτερη Δύναμη",
  "block.minecraft.bed.no_sleep": "Μπορείς να κοιμηθείς μόνο τη νύχτα ή κατά τη διάρκεια καταιγίδων",
  "block.minecraft.bed.not_safe": "Δεν μπορείς να κοιμηθείς τώρα· υπάρχουν τέρατα κοντά",
  "block.minecraft.bed.obstructed": "Αυτό το κρεβάτι είναι παρεμποδισμένο",
  "block.minecraft.bed.occupied": "Αυτό το κρεβάτι είναι κατειλημμένο",
  "block.minecraft.bed.too_far_away": "Δεν μπορείς να κοιμηθείς τώρα· το κρεβάτι βρίσκεται πολύ μακριά",
  "block.minecraft.bedrock": "Βραχώδες Υπόστρωμα",
  "block.minecraft.bee_nest": "Μελισσοφωλιά",
  "block.minecraft.beehive": "Κυψέλη",
  "block.minecraft.beetroots": "Παντζάρια",
  "block.minecraft.bell": "Καμπάνα",
  "block.minecraft.big_dripleaf": "Μεγάλο Σταλόφυλλο",
  "block.minecraft.big_dripleaf_stem": "Βλαστός Μεγάλου Σταλόφυλλου",
  "block.minecraft.birch_button": "Κουμπί Σημύδας",
  "block.minecraft.birch_door": "Πόρτα Σημύδας",
  "block.minecraft.birch_fence": "Φράχτης Σημύδας",
  "block.minecraft.birch_fence_gate": "Πύλη Φράχτη Σημύδας",
  "block.minecraft.birch_hanging_sign": "Κρεμαστή Πινακίδα Σημύδας",
  "block.minecraft.birch_leaves": "Φύλλα Σημύδας",
  "block.minecraft.birch_log": "Κορμός Σημύδας",
  "block.minecraft.birch_planks": "Σανίδες Σημύδας",
  "block.minecraft.birch_pressure_plate": "Πλάκα Πίεσης Σημύδας",
  "block.minecraft.birch_sapling": "Βλαστάρι Σημύδας",
  "block.minecraft.birch_shelf": "Ράφι Σημύδας",
  "block.minecraft.birch_sign": "Πινακίδα Σημύδας",
  "block.minecraft.birch_slab": "Πλάκα Σημύδας",
  "block.minecraft.birch_stairs": "Σκάλες Σημύδας",
  "block.minecraft.birch_trapdoor": "Καταπακτή Σημύδας",
  "block.minecraft.birch_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Σημύδας",
  "block.minecraft.birch_wall_sign": "Πινακίδα Τοίχου Σημύδας",
  "block.minecraft.birch_wood": "Ξύλο Σημύδας",
  "block.minecraft.black_banner": "Μαύρο Λάβαρο",
  "block.minecraft.black_bed": "Μαύρο Κρεβάτι",
  "block.minecraft.black_candle": "Μαύρο Κερί",
  "block.minecraft.black_candle_cake": "Τούρτα με Μαύρο Κερί",
  "block.minecraft.black_carpet": "Μαύρο Χαλί",
  "block.minecraft.black_concrete": "Μαύρο Σκυρόδεμα",
  "block.minecraft.black_concrete_powder": "Μαύρη Σκόνη Σκυροδέματος",
  "block.minecraft.black_glazed_terracotta": "Μαύρη Γυαλισμένη Τερακότα",
  "block.minecraft.black_shulker_box": "Μαύρο Κιβώτιο Σάλκερ",
  "block.minecraft.black_stained_glass": "Μαύρο Χρωματισμένο Γυαλί",
  "block.minecraft.black_stained_glass_pane": "Μαύρος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.black_terracotta": "Μαύρη Τερακότα",
  "block.minecraft.black_wool": "Μαύρο Μαλλί",
  "block.minecraft.blackstone": "Μαυρόπετρα",
  "block.minecraft.blackstone_slab": "Πλάκα Μαυρόπετρας",
  "block.minecraft.blackstone_stairs": "Σκάλες Μαυρόπετρας",
  "block.minecraft.blackstone_wall": "Τοίχος Μαυρόπετρας",
  "block.minecraft.blast_furnace": "Υψικάμινος",
  "block.minecraft.blue_banner": "Μπλε Λάβαρο",
  "block.minecraft.blue_bed": "Μπλε Κρεβάτι",
  "block.minecraft.blue_candle": "Μπλε Κερί",
  "block.minecraft.blue_candle_cake": "Τούρτα με Μπλε Κερί",
  "block.minecraft.blue_carpet": "Μπλε Χαλί",
  "block.minecraft.blue_concrete": "Μπλε Σκυρόδεμα",
  "block.minecraft.blue_concrete_powder": "Μπλε Σκόνη Σκυροδέματος",
  "block.minecraft.blue_glazed_terracotta": "Μπλε Γυαλισμένη Τερακότα",
  "block.minecraft.blue_ice": "Μπλε Πάγος",
  "block.minecraft.blue_orchid": "Μπλε Ορχιδέα",
  "block.minecraft.blue_shulker_box": "Μπλε Κιβώτιο Σάλκερ",
  "block.minecraft.blue_stained_glass": "Μπλε Χρωματισμένο Γυαλί",
  "block.minecraft.blue_stained_glass_pane": "Μπλε Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.blue_terracotta": "Μπλε Τερακότα",
  "block.minecraft.blue_wool": "Μπλε Μαλλί",
  "block.minecraft.bone_block": "Κύβος Οστών",
  "block.minecraft.bookshelf": "Βιβλιοθήκη",
  "block.minecraft.brain_coral": "Ροζ Κοράλλι",
  "block.minecraft.brain_coral_block": "Κύβος Ροζ Κοραλλιού",
  "block.minecraft.brain_coral_fan": "Ροζ Αλκυονοειδές Κοράλλι",
  "block.minecraft.brain_coral_wall_fan": "Ροζ Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.brewing_stand": "Πάγκος Παρασκευής",
  "block.minecraft.brick_slab": "Πλάκα Τούβλων",
  "block.minecraft.brick_stairs": "Σκάλες Τούβλων",
  "block.minecraft.brick_wall": "Τοίχος Τούβλων",
  "block.minecraft.bricks": "Τούβλα",
  "block.minecraft.brown_banner": "Καφέ Λάβαρο",
  "block.minecraft.brown_bed": "Καφέ Κρεβάτι",
  "block.minecraft.brown_candle": "Καφέ Κερί",
  "block.minecraft.brown_candle_cake": "Τούρτα με Καφέ Κερί",
  "block.minecraft.brown_carpet": "Καφέ Χαλί",
  "block.minecraft.brown_concrete": "Καφέ Σκυρόδεμα",
  "block.minecraft.brown_concrete_powder": "Καφέ Σκόνη Σκυροδέματος",
  "block.minecraft.brown_glazed_terracotta": "Καφέ Γυαλισμένη Τερακότα",
  "block.minecraft.brown_mushroom": "Καφέ Μανιτάρι",
  "block.minecraft.brown_mushroom_block": "Κύβος Καφέ Μανιταριού",
  "block.minecraft.brown_shulker_box": "Καφέ Κιβώτιο Σάλκερ",
  "block.minecraft.brown_stained_glass": "Καφέ Χρωματισμένο Γυαλί",
  "block.minecraft.brown_stained_glass_pane": "Καφέ Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.brown_terracotta": "Καφέ Τερακότα",
  "block.minecraft.brown_wool": "Καφέ Μαλλί",
  "block.minecraft.bubble_column": "Στήλη Φυσαλίδων",
  "block.minecraft.bubble_coral": "Μοβ Κοράλλι",
  "block.minecraft.bubble_coral_block": "Κύβος Μοβ Κοραλλιού",
  "block.minecraft.bubble_coral_fan": "Μοβ Αλκυονοειδές Κοράλλι",
  "block.minecraft.bubble_coral_wall_fan": "Μοβ Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.budding_amethyst": "Μπουμπουκιασμένος Αμέθυστος",
  "block.minecraft.bush": "Θάμνος",
  "block.minecraft.cactus": "Κάκτος",
  "block.minecraft.cactus_flower": "Άνθος Κάκτου",
  "block.minecraft.cake": "Τούρτα",
  "block.minecraft.calcite": "Ασβεστίτης",
  "block.minecraft.calibrated_sculk_sensor": "Ρυθμιζόμενος Αισθητήρας Σκαλκ",
  "block.minecraft.campfire": "Φωτιά Κατασκήνωσης",
  "block.minecraft.candle": "Κερί",
  "block.minecraft.candle_cake": "Τούρτα με Κερί",
  "block.minecraft.carrots": "Καρώτα",
  "block.minecraft.cartography_table": "Τραπέζι Χαρτογραφίας",
  "block.minecraft.carved_pumpkin": "Σκαλισμένη Κολοκύθα",
  "block.minecraft.cauldron": "Καζάνι",
  "block.minecraft.cave_air": "Αέρας Σπηλιάς",
  "block.minecraft.cave_vines": "Κληματσίδες Σπηλιάς",
  "block.minecraft.cave_vines_plant": "Φυτό Κληματσίδων Σπηλιάς",
  "block.minecraft.chain": "Αλυσίδα",
  "block.minecraft.chain_command_block": "Κύβος Εντολής Αλυσίδας",
  "block.minecraft.cherry_button": "Κουμπί Κερασιάς",
  "block.minecraft.cherry_door": "Πόρτα Κερασιάς",
  "block.minecraft.cherry_fence": "Φράχτης Κερασιάς",
  "block.minecraft.cherry_fence_gate": "Πύλη Φράχτη Κερασιάς",
  "block.minecraft.cherry_hanging_sign": "Κρεμαστή Πινακίδα Κερασιάς",
  "block.minecraft.cherry_leaves": "Φύλλα Κερασιάς",
  "block.minecraft.cherry_log": "Κορμός Κερασιάς",
  "block.minecraft.cherry_planks": "Σανίδες Κερασιάς",
  "block.minecraft.cherry_pressure_plate": "Πλάκα Πίεσης Κερασιάς",
  "block.minecraft.cherry_sapling": "Βλαστάρι Κερασιάς",
  "block.minecraft.cherry_shelf": "Ράφι Κερασιάς",
  "block.minecraft.cherry_sign": "Πινακίδα Κερασιάς",
  "block.minecraft.cherry_slab": "Πλάκα Κερασιάς",
  "block.minecraft.cherry_stairs": "Σκάλες Κερασιάς",
  "block.minecraft.cherry_trapdoor": "Καταπακτή Κερασιάς",
  "block.minecraft.cherry_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Κερασιάς",
  "block.minecraft.cherry_wall_sign": "Πινακίδα Τοίχου Κερασιάς",
  "block.minecraft.cherry_wood": "Ξύλο Κερασιάς",
  "block.minecraft.chest": "Σεντούκι",
  "block.minecraft.chipped_anvil": "Φθαρμένο Αμόνι",
  "block.minecraft.chiseled_bookshelf": "Λαξευμένη Βιβλιοθήκη",
  "block.minecraft.chiseled_copper": "Λαξευμένος Χαλκός",
  "block.minecraft.chiseled_deepslate": "Λαξευμένος Βαθόλιθος",
  "block.minecraft.chiseled_nether_bricks": "Λαξευμένα Τούβλα Νέδερ",
  "block.minecraft.chiseled_polished_blackstone": "Λαξευμένη Γυαλισμένη Μαυρόπετρα",
  "block.minecraft.chiseled_quartz_block": "Κύβος Λαξευμένου Χαλαζία",
  "block.minecraft.chiseled_red_sandstone": "Λαξευμένη Κόκκινη Αμμόπετρα",
  "block.minecraft.chiseled_resin_bricks": "Λαξευμένα Τούβλα Ρητίνης",
  "block.minecraft.chiseled_sandstone": "Λαξευμένη Αμμόπετρα",
  "block.minecraft.chiseled_stone_bricks": "Λαξευμένα Τούβλα Πέτρας",
  "block.minecraft.chiseled_tuff": "Λαξευμένος Τόφος",
  "block.minecraft.chiseled_tuff_bricks": "Λαξευμένα Τούβλα Τόφου",
  "block.minecraft.chorus_flower": "Χορικό Άνθος",
  "block.minecraft.chorus_plant": "Χορικό Φυτό",
  "block.minecraft.clay": "Πηλός",
  "block.minecraft.closed_eyeblossom": "Κλειστός Οφθάλμανθος",
  "block.minecraft.coal_block": "Κύβος Κάρβουνου",
  "block.minecraft.coal_ore": "Μετάλλευμα Κάρβουνου",
  "block.minecraft.coarse_dirt": "Τραχύ Χώμα",
  "block.minecraft.cobbled_deepslate": "Λιθόστρωτος Βαθόλιθος",
  "block.minecraft.cobbled_deepslate_slab": "Πλάκα Λιθόστρωτου Βαθόλιθου",
  "block.minecraft.cobbled_deepslate_stairs": "Σκάλες Λιθόστρωτου Βαθόλιθου",
  "block.minecraft.cobbled_deepslate_wall": "Τοίχος Λιθόστρωτου Βαθόλιθου",
  "block.minecraft.cobblestone": "Κροκάλα",
  "block.minecraft.cobblestone_slab": "Πλάκα Κροκάλας",
  "block.minecraft.cobblestone_stairs": "Σκάλες Κροκάλας",
  "block.minecraft.cobblestone_wall": "Τοίχος Κροκάλας",
  "block.minecraft.cobweb": "Ιστός Αράχνης",
  "block.minecraft.cocoa": "Κακάο",
  "block.minecraft.command_block": "Κύβος Εντολής",
  "block.minecraft.comparator": "Συγκριτής Ρέντστοουν",
  "block.minecraft.composter": "Κομποστοποιητής",
  "block.minecraft.conduit": "Αγωγός",
  "block.minecraft.copper_bars": "Κάγκελα Χαλκού",
  "block.minecraft.copper_block": "Κύβος Χαλκού",
  "block.minecraft.copper_bulb": "Λάμπα Χαλκού",
  "block.minecraft.copper_chain": "Αλυσίδα Χαλκού",
  "block.minecraft.copper_chest": "Σεντούκι Χαλκού",
  "block.minecraft.copper_door": "Πόρτα Χαλκού",
  "block.minecraft.copper_golem_statue": "Άγαλμα Γκόλεμ Χαλκού",
  "block.minecraft.copper_grate": "Σχάρα Χαλκού",
  "block.minecraft.copper_lantern": "Φανάρι Χαλκού",
  "block.minecraft.copper_ore": "Μετάλλευμα Χαλκού",
  "block.minecraft.copper_torch": "Πυρσός Χαλκού",
  "block.minecraft.copper_trapdoor": "Καταπακτή Χαλκού",
  "block.minecraft.copper_wall_torch": "Πυρσός Τοίχου Χαλκού",
  "block.minecraft.cornflower": "Κενταύρια",
  "block.minecraft.cracked_deepslate_bricks": "Ραγισμένα Τούβλα Βαθόλιθου",
  "block.minecraft.cracked_deepslate_tiles": "Ραγισμένα Πλακίδια Βαθόλιθου",
  "block.minecraft.cracked_nether_bricks": "Ραγισμένα Τούβλα Νέδερ",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ραγισμένα Γυαλισμένα Τούβλα Μαυρόπετρας",
  "block.minecraft.cracked_stone_bricks": "Ραγισμένα Τούβλα Πέτρας",
  "block.minecraft.crafter": "Κατασκευαστής",
  "block.minecraft.crafting_table": "Τραπέζι Κατασκευής",
  "block.minecraft.creaking_heart": "Καρδιά Τριξιτή",
  "block.minecraft.creeper_head": "Κεφάλι Κρίπερ",
  "block.minecraft.creeper_wall_head": "Κεφάλι Τοίχου Κρίπερ",
  "block.minecraft.crimson_button": "Ερυθρό Κουμπί",
  "block.minecraft.crimson_door": "Ερυθρή Πόρτα",
  "block.minecraft.crimson_fence": "Ερυθρός Φράχτης",
  "block.minecraft.crimson_fence_gate": "Ερυθρή Πύλη Φράχτη",
  "block.minecraft.crimson_fungus": "Ερυθρός Μύκητας",
  "block.minecraft.crimson_hanging_sign": "Ερυθρή Κρεμαστή Πινακίδα",
  "block.minecraft.crimson_hyphae": "Ερυθρές Υφές",
  "block.minecraft.crimson_nylium": "Ερυθρό Νύλιο",
  "block.minecraft.crimson_planks": "Ερυθρές Σανίδες",
  "block.minecraft.crimson_pressure_plate": "Ερυθρή Πλάκα Πίεσης",
  "block.minecraft.crimson_roots": "Ερυθρές Ρίζες",
  "block.minecraft.crimson_shelf": "Ερυθρό Ράφι",
  "block.minecraft.crimson_sign": "Ερυθρή Πινακίδα",
  "block.minecraft.crimson_slab": "Ερυθρή Πλάκα",
  "block.minecraft.crimson_stairs": "Ερυθρές Σκάλες",
  "block.minecraft.crimson_stem": "Ερυθρός Βλαστός",
  "block.minecraft.crimson_trapdoor": "Ερυθρή Καταπακτή",
  "block.minecraft.crimson_wall_hanging_sign": "Ερυθρή Κρεμαστή Πινακίδα Τοίχου",
  "block.minecraft.crimson_wall_sign": "Ερυθρή Πινακίδα Τοίχου",
  "block.minecraft.crying_obsidian": "Δακρυσμένος Οψιδιανός",
  "block.minecraft.cut_copper": "Κομμένος Χαλκός",
  "block.minecraft.cut_copper_slab": "Πλάκα Κομμένου Χαλκού",
  "block.minecraft.cut_copper_stairs": "Σκάλες Κομμένου Χαλκού",
  "block.minecraft.cut_red_sandstone": "Κομμένη Κόκκινη Αμμόπετρα",
  "block.minecraft.cut_red_sandstone_slab": "Πλάκα Κομμένης Κόκκινης Αμμόπετρας",
  "block.minecraft.cut_sandstone": "Κομμένη Αμμόπετρα",
  "block.minecraft.cut_sandstone_slab": "Πλάκα Κομμένης Αμμόπετρας",
  "block.minecraft.cyan_banner": "Κυανό Λάβαρο",
  "block.minecraft.cyan_bed": "Κυανό Κρεβάτι",
  "block.minecraft.cyan_candle": "Κυανό Κερί",
  "block.minecraft.cyan_candle_cake": "Τούρτα με Κυανό Κερί",
  "block.minecraft.cyan_carpet": "Κυανό Χαλί",
  "block.minecraft.cyan_concrete": "Κυανό Σκυρόδεμα",
  "block.minecraft.cyan_concrete_powder": "Κυανή Σκόνη Σκυροδέματος",
  "block.minecraft.cyan_glazed_terracotta": "Κυανή Γυαλισμένη Τερακότα",
  "block.minecraft.cyan_shulker_box": "Κυανό Κιβώτιο Σάλκερ",
  "block.minecraft.cyan_stained_glass": "Κυανό Χρωματισμένο Γυαλί",
  "block.minecraft.cyan_stained_glass_pane": "Κυανός Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.cyan_terracotta": "Κυανή Τερακότα",
  "block.minecraft.cyan_wool": "Κυανό Μαλλί",
  "block.minecraft.damaged_anvil": "Κατεστραμμένο Αμόνι",
  "block.minecraft.dandelion": "Πικραλίδα",
  "block.minecraft.dark_oak_button": "Κουμπί Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_door": "Πόρτα Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_fence": "Φράχτης Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_fence_gate": "Πύλη Φράχτη Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_hanging_sign": "Κρεμαστή Πινακίδα Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_leaves": "Φύλλα Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_log": "Κορμός Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_planks": "Σανίδες Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_pressure_plate": "Πλάκα Πίεσης Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_sapling": "Βλαστάρι Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_shelf": "Ράφι Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_sign": "Πινακίδα Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_slab": "Πλάκα Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_stairs": "Σκάλες Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_trapdoor": "Καταπακτή Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_wall_sign": "Πινακίδα Τοίχου Σκούρας Βελανιδιάς",
  "block.minecraft.dark_oak_wood": "Ξύλο Σκούρας Βελανιδιάς",
  "block.minecraft.dark_prismarine": "Σκούρα Πρισμαρίνη",
  "block.minecraft.dark_prismarine_slab": "Πλάκα Σκούρας Πρισμαρίνης",
  "block.minecraft.dark_prismarine_stairs": "Σκάλες Σκούρας Πρισμαρίνης",
  "block.minecraft.daylight_detector": "Ανιχνευτής Φωτός Ημέρας",
  "block.minecraft.dead_brain_coral": "Νεκρό Ροζ Κοράλλι",
  "block.minecraft.dead_brain_coral_block": "Κύβος Νεκρού Ροζ Κοραλλιού",
  "block.minecraft.dead_brain_coral_fan": "Νεκρό Ροζ Αλκυονοειδές Κοράλλι",
  "block.minecraft.dead_brain_coral_wall_fan": "Νεκρό Ροζ Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.dead_bubble_coral": "Νεκρό Μοβ Κοράλλι",
  "block.minecraft.dead_bubble_coral_block": "Κύβος Νεκρού Μοβ Κοραλλιού",
  "block.minecraft.dead_bubble_coral_fan": "Νεκρό Μοβ Αλκυονοειδές Κοράλλι",
  "block.minecraft.dead_bubble_coral_wall_fan": "Νεκρό Μοβ Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.dead_bush": "Ξερός Θάμνος",
  "block.minecraft.dead_fire_coral": "Νεκρό Κόκκινο Κοράλλι",
  "block.minecraft.dead_fire_coral_block": "Κύβος Νεκρού Κόκκινου Κοραλλιού",
  "block.minecraft.dead_fire_coral_fan": "Νεκρό Κόκκινο Αλκυονοειδές Κοράλλι",
  "block.minecraft.dead_fire_coral_wall_fan": "Νεκρό Κόκκινο Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.dead_horn_coral": "Νεκρό Κίτρινο Κοράλλι",
  "block.minecraft.dead_horn_coral_block": "Κύβος Νεκρού Κίτρινου Κοραλλιού",
  "block.minecraft.dead_horn_coral_fan": "Νεκρό Κίτρινο Αλκυονοειδές Κοράλλι",
  "block.minecraft.dead_horn_coral_wall_fan": "Νεκρό Κίτρινο Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.dead_tube_coral": "Νεκρό Μπλε Κοράλλι",
  "block.minecraft.dead_tube_coral_block": "Κύβος Νεκρού Μπλε Κοραλλιού",
  "block.minecraft.dead_tube_coral_fan": "Νεκρό Μπλε Αλκυονοειδές Κοράλλι",
  "block.minecraft.dead_tube_coral_wall_fan": "Νεκρό Μπλε Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.decorated_pot": "Διακοσμημένο Αγγείο",
  "block.minecraft.deepslate": "Βαθόλιθος",
  "block.minecraft.deepslate_brick_slab": "Πλάκα Τούβλων Βαθόλιθου",
  "block.minecraft.deepslate_brick_stairs": "Σκάλες Τούβλων Βαθόλιθου",
  "block.minecraft.deepslate_brick_wall": "Τοίχος Τούβλων Βαθόλιθου",
  "block.minecraft.deepslate_bricks": "Τούβλα Βαθόλιθου",
  "block.minecraft.deepslate_coal_ore": "Μετάλλευμα Κάρβουνου Βαθόλιθου",
  "block.minecraft.deepslate_copper_ore": "Μετάλλευμα Χαλκού Βαθόλιθου",
  "block.minecraft.deepslate_diamond_ore": "Μετάλλευμα Διαμαντιού Βαθόλιθου",
  "block.minecraft.deepslate_emerald_ore": "Μετάλλευμα Σμαραγδιού Βαθόλιθου",
  "block.minecraft.deepslate_gold_ore": "Μετάλλευμα Χρυσού Βαθόλιθου",
  "block.minecraft.deepslate_iron_ore": "Μετάλλευμα Σιδήρου Βαθόλιθου",
  "block.minecraft.deepslate_lapis_ore": "Μετάλλευμα Λάπις Λάζουλι Βαθόλιθου",
  "block.minecraft.deepslate_redstone_ore": "Μετάλλευμα Ρέντστοουν Βαθόλιθου",
  "block.minecraft.deepslate_tile_slab": "Πλάκα Πλακιδίων Βαθόλιθου",
  "block.minecraft.deepslate_tile_stairs": "Σκάλες Πλακιδίων Βαθόλιθου",
  "block.minecraft.deepslate_tile_wall": "Τοίχος Πλακιδίων Βαθόλιθου",
  "block.minecraft.deepslate_tiles": "Πλακίδια Βαθόλιθου",
  "block.minecraft.detector_rail": "Ράγα Ανίχνευσης",
  "block.minecraft.diamond_block": "Κύβος Διαμαντιού",
  "block.minecraft.diamond_ore": "Μετάλλευμα Διαμαντιού",
  "block.minecraft.diorite": "Διορίτης",
  "block.minecraft.diorite_slab": "Πλάκα Διορίτη",
  "block.minecraft.diorite_stairs": "Σκάλες Διορίτη",
  "block.minecraft.diorite_wall": "Τοίχος Διορίτη",
  "block.minecraft.dirt": "Χώμα",
  "block.minecraft.dirt_path": "Μονοπάτι Χώματος",
  "block.minecraft.dispenser": "Διανομέας",
  "block.minecraft.dragon_egg": "Αβγό Δράκου",
  "block.minecraft.dragon_head": "Κεφάλι Δράκου",
  "block.minecraft.dragon_wall_head": "Κεφάλι Τοίχου Δράκου",
  "block.minecraft.dried_ghast": "Αφυδατωμένο Γκαστ",
  "block.minecraft.dried_kelp_block": "Κύβος Αποξηραμένου Φυκιού",
  "block.minecraft.dripstone_block": "Κύβος Σταλόπετρας",
  "block.minecraft.dropper": "Ρίχτης",
  "block.minecraft.emerald_block": "Κύβος Σμαραγδιού",
  "block.minecraft.emerald_ore": "Μετάλλευμα Σμαραγδιού",
  "block.minecraft.enchanting_table": "Τραπέζι Μαγέματος",
  "block.minecraft.end_gateway": "Πύλη Μεταφοράς Εντ",
  "block.minecraft.end_portal": "Πύλη Εντ",
  "block.minecraft.end_portal_frame": "Πλαίσιο Πύλης Εντ",
  "block.minecraft.end_rod": "Ράβδος Εντ",
  "block.minecraft.end_stone": "Πέτρα Εντ",
  "block.minecraft.end_stone_brick_slab": "Πλάκα Τούβλων Πέτρας Εντ",
  "block.minecraft.end_stone_brick_stairs": "Σκάλες Τούβλων Πέτρας Εντ",
  "block.minecraft.end_stone_brick_wall": "Τοίχος Τούβλων Πέτρας Εντ",
  "block.minecraft.end_stone_bricks": "Τούβλα Πέτρας Εντ",
  "block.minecraft.ender_chest": "Σεντούκι Έντερ",
  "block.minecraft.exposed_chiseled_copper": "Εκτεθειμένος Λαξευμένος Χαλκός",
  "block.minecraft.exposed_copper": "Εκτεθειμένος Χαλκός",
  "block.minecraft.exposed_copper_bars": "Κάγκελα Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_bulb": "Λάμπα Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_chain": "Αλυσίδα Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_chest": "Σεντούκι Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_door": "Πόρτα Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_golem_statue": "Άγαλμα Γκόλεμ Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_grate": "Σχάρα Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_lantern": "Φανάρι Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_copper_trapdoor": "Καταπακτή Εκτεθειμένου Χαλκού",
  "block.minecraft.exposed_cut_copper": "Εκτεθειμένος Κομμένος Χαλκός",
  "block.minecraft.exposed_cut_copper_slab": "Πλάκα Εκτεθειμένου Κομμένου Χαλκού",
  "block.minecraft.exposed_cut_copper_stairs": "Σκάλες Εκτεθειμένου Κομμένου Χαλκού",
  "block.minecraft.exposed_lightning_rod": "Εκτεθειμένο Αλεξικέραυνο",
  "block.minecraft.farmland": "Οργωμένο Χώμα",
  "block.minecraft.fern": "Φτέρη",
  "block.minecraft.fire": "Φωτιά",
  "block.minecraft.fire_coral": "Κόκκινο Κοράλλι",
  "block.minecraft.fire_coral_block": "Κύβος Κόκκινου Κοραλλιού",
  "block.minecraft.fire_coral_fan": "Κόκκινο Αλκυονοειδές Κοράλλι",
  "block.minecraft.fire_coral_wall_fan": "Κόκκινο Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.firefly_bush": "Θάμνος Πυγολαμπίδων",
  "block.minecraft.fletching_table": "Τραπέζι Κατασκευής Βελών",
  "block.minecraft.flower_pot": "Γλάστρα",
  "block.minecraft.flowering_azalea": "Ανθισμένη Αζαλέα",
  "block.minecraft.flowering_azalea_leaves": "Φύλλα Ανθισμένης Αζαλέας",
  "block.minecraft.frogspawn": "Αβγά Βατράχου",
  "block.minecraft.frosted_ice": "Ψυχρός Πάγος",
  "block.minecraft.furnace": "Φούρνος",
  "block.minecraft.gilded_blackstone": "Επιχρυσωμένη Μαυρόπετρα",
  "block.minecraft.glass": "Γυαλί",
  "block.minecraft.glass_pane": "Υαλοπίνακας",
  "block.minecraft.glow_lichen": "Λαμπερή Λειχήνα",
  "block.minecraft.glowstone": "Λαμψόπετρα",
  "block.minecraft.gold_block": "Κύβος Χρυσού",
  "block.minecraft.gold_ore": "Μετάλλευμα Χρυσού",
  "block.minecraft.golden_dandelion": "Χρυσή Πικραλίδα",
  "block.minecraft.granite": "Γρανίτης",
  "block.minecraft.granite_slab": "Πλάκα Γρανίτη",
  "block.minecraft.granite_stairs": "Σκάλες Γρανίτη",
  "block.minecraft.granite_wall": "Τοίχος Γρανίτη",
  "block.minecraft.grass": "Γρασίδι",
  "block.minecraft.grass_block": "Κύβος Γρασιδιού",
  "block.minecraft.gravel": "Χαλίκι",
  "block.minecraft.gray_banner": "Γκρίζο Λάβαρο",
  "block.minecraft.gray_bed": "Γκρίζο Κρεβάτι",
  "block.minecraft.gray_candle": "Γκρίζο Κερί",
  "block.minecraft.gray_candle_cake": "Τούρτα με Γκρίζο Κερί",
  "block.minecraft.gray_carpet": "Γκρίζο Χαλί",
  "block.minecraft.gray_concrete": "Γκρίζο Σκυρόδεμα",
  "block.minecraft.gray_concrete_powder": "Γκρίζα Σκόνη Σκυροδέματος",
  "block.minecraft.gray_glazed_terracotta": "Γκρίζα Γυαλισμένη Τερακότα",
  "block.minecraft.gray_shulker_box": "Γκρίζο Κιβώτιο Σάλκερ",
  "block.minecraft.gray_stained_glass": "Γκρίζο Χρωματισμένο Γυαλί",
  "block.minecraft.gray_stained_glass_pane": "Γκρίζος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.gray_terracotta": "Γκρίζα Τερακότα",
  "block.minecraft.gray_wool": "Γκρίζο Μαλλί",
  "block.minecraft.green_banner": "Πράσινο Λάβαρο",
  "block.minecraft.green_bed": "Πράσινο Κρεβάτι",
  "block.minecraft.green_candle": "Πράσινο Κερί",
  "block.minecraft.green_candle_cake": "Τούρτα με Πράσινο Κερί",
  "block.minecraft.green_carpet": "Πράσινο Χαλί",
  "block.minecraft.green_concrete": "Πράσινο Σκυρόδεμα",
  "block.minecraft.green_concrete_powder": "Πράσινη Σκόνη Σκυροδέματος",
  "block.minecraft.green_glazed_terracotta": "Πράσινη Γυαλισμένη Τερακότα",
  "block.minecraft.green_shulker_box": "Πράσινο Κιβώτιο Σάλκερ",
  "block.minecraft.green_stained_glass": "Πράσινο Χρωματισμένο Γυαλί",
  "block.minecraft.green_stained_glass_pane": "Πράσινος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.green_terracotta": "Πράσινη Τερακότα",
  "block.minecraft.green_wool": "Πράσινο Μαλλί",
  "block.minecraft.grindstone": "Ακονόπετρα",
  "block.minecraft.hanging_roots": "Κρεμαστές Ρίζες",
  "block.minecraft.hay_block": "Δεμάτι Σανού",
  "block.minecraft.heavy_core": "Βαρύς Πυρήνας",
  "block.minecraft.heavy_weighted_pressure_plate": "Πλάκα Πίεσης Μεγάλου Βάρους",
  "block.minecraft.honey_block": "Κύβος Μελιού",
  "block.minecraft.honeycomb_block": "Κύβος Κηρήθρας",
  "block.minecraft.hopper": "Χοάνη",
  "block.minecraft.horn_coral": "Κίτρινο Κοράλλι",
  "block.minecraft.horn_coral_block": "Κύβος Κίτρινου Κοραλλιού",
  "block.minecraft.horn_coral_fan": "Κίτρινο Αλκυονοειδές Κοράλλι",
  "block.minecraft.horn_coral_wall_fan": "Κίτρινο Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.ice": "Πάγος",
  "block.minecraft.infested_chiseled_stone_bricks": "Μολυσμένα Λαξευμένα Τούβλα Πέτρας",
  "block.minecraft.infested_cobblestone": "Μολυσμένη Κροκάλα",
  "block.minecraft.infested_cracked_stone_bricks": "Μολυσμένα Ραγισμένα Τούβλα Πέτρας",
  "block.minecraft.infested_deepslate": "Μολυσμένος Βαθόλιθος",
  "block.minecraft.infested_mossy_stone_bricks": "Μολυσμένα Βρυώδη Τούβλα Πέτρας",
  "block.minecraft.infested_stone": "Μολυσμένη Πέτρα",
  "block.minecraft.infested_stone_bricks": "Μολυσμένα Τούβλα Πέτρας",
  "block.minecraft.iron_bars": "Κάγκελα Σιδήρου",
  "block.minecraft.iron_block": "Κύβος Σιδήρου",
  "block.minecraft.iron_chain": "Αλυσίδα Σιδήρου",
  "block.minecraft.iron_door": "Πόρτα Σιδήρου",
  "block.minecraft.iron_ore": "Μετάλλευμα Σιδήρου",
  "block.minecraft.iron_trapdoor": "Καταπακτή Σιδήρου",
  "block.minecraft.jack_o_lantern": "Φανάρι Κολοκύθας",
  "block.minecraft.jigsaw": "Κύβος Παζλ",
  "block.minecraft.jukebox": "Τζούκμποξ",
  "block.minecraft.jungle_button": "Κουμπί Ζούγκλας",
  "block.minecraft.jungle_door": "Πόρτα Ζούγκλας",
  "block.minecraft.jungle_fence": "Φράχτης Ζούγκλας",
  "block.minecraft.jungle_fence_gate": "Πύλη Φράχτη Ζούγκλας",
  "block.minecraft.jungle_hanging_sign": "Κρεμαστή Πινακίδα Ζούγκλας",
  "block.minecraft.jungle_leaves": "Φύλλα Ζούγκλας",
  "block.minecraft.jungle_log": "Κορμός Ζούγκλας",
  "block.minecraft.jungle_planks": "Σανίδες Ζούγκλας",
  "block.minecraft.jungle_pressure_plate": "Πλάκα Πίεσης Ζούγκλας",
  "block.minecraft.jungle_sapling": "Βλαστάρι Ζούγκλας",
  "block.minecraft.jungle_shelf": "Ράφι Ζούγκλας",
  "block.minecraft.jungle_sign": "Πινακίδα Ζούγκλας",
  "block.minecraft.jungle_slab": "Πλάκα Ζούγκλας",
  "block.minecraft.jungle_stairs": "Σκάλες Ζούγκλας",
  "block.minecraft.jungle_trapdoor": "Καταπακτή Ζούγκλας",
  "block.minecraft.jungle_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Ζούγκλας",
  "block.minecraft.jungle_wall_sign": "Πινακίδα Τοίχου Ζούγκλας",
  "block.minecraft.jungle_wood": "Ξύλο Ζούγκλας",
  "block.minecraft.kelp": "Φύκι",
  "block.minecraft.kelp_plant": "Φυτό Φυκιού",
  "block.minecraft.ladder": "Σκάλα",
  "block.minecraft.lantern": "Φανάρι",
  "block.minecraft.lapis_block": "Κύβος Λάπις Λάζουλι",
  "block.minecraft.lapis_ore": "Μετάλλευμα Λάπις Λάζουλι",
  "block.minecraft.large_amethyst_bud": "Μεγάλο Μπουμπούκι Αμέθυστου",
  "block.minecraft.large_fern": "Μεγάλη Φτέρη",
  "block.minecraft.lava": "Λάβα",
  "block.minecraft.lava_cauldron": "Καζάνι Λάβας",
  "block.minecraft.leaf_litter": "Στρώμα Φύλλων",
  "block.minecraft.lectern": "Αναλόγιο",
  "block.minecraft.lever": "Μοχλός",
  "block.minecraft.light": "Φως",
  "block.minecraft.light_blue_banner": "Γαλάζιο Λάβαρο",
  "block.minecraft.light_blue_bed": "Γαλάζιο Κρεβάτι",
  "block.minecraft.light_blue_candle": "Γαλάζιο Κερί",
  "block.minecraft.light_blue_candle_cake": "Τούρτα με Γαλάζιο Κερί",
  "block.minecraft.light_blue_carpet": "Γαλάζιο Χαλί",
  "block.minecraft.light_blue_concrete": "Γαλάζιο Σκυρόδεμα",
  "block.minecraft.light_blue_concrete_powder": "Γαλάζια Σκόνη Σκυροδέματος",
  "block.minecraft.light_blue_glazed_terracotta": "Γαλάζια Γυαλισμένη Τερακότα",
  "block.minecraft.light_blue_shulker_box": "Γαλάζιο Κιβώτιο Σάλκερ",
  "block.minecraft.light_blue_stained_glass": "Γαλάζιο Χρωματισμένο Γυαλί",
  "block.minecraft.light_blue_stained_glass_pane": "Γαλάζιος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.light_blue_terracotta": "Γαλάζια Τερακότα",
  "block.minecraft.light_blue_wool": "Γαλάζιο Μαλλί",
  "block.minecraft.light_gray_banner": "Ανοιχτό Γκρίζο Λάβαρο",
  "block.minecraft.light_gray_bed": "Ανοιχτό Γκρίζο Κρεβάτι",
  "block.minecraft.light_gray_candle": "Ανοιχτό Γκρίζο Κερί",
  "block.minecraft.light_gray_candle_cake": "Τούρτα με Ανοιχτό Γκρίζο Κερί",
  "block.minecraft.light_gray_carpet": "Ανοιχτό Γκρίζο Χαλί",
  "block.minecraft.light_gray_concrete": "Ανοιχτό Γκρίζο Σκυρόδεμα",
  "block.minecraft.light_gray_concrete_powder": "Ανοιχτή Γκρίζα Σκόνη Σκυροδέματος",
  "block.minecraft.light_gray_glazed_terracotta": "Ανοιχτή Γκρίζα Γυαλισμένη Τερακότα",
  "block.minecraft.light_gray_shulker_box": "Ανοιχτό Γκρίζο Κιβώτιο Σάλκερ",
  "block.minecraft.light_gray_stained_glass": "Ανοιχτό Γκρίζο Χρωματισμένο Γυαλί",
  "block.minecraft.light_gray_stained_glass_pane": "Ανοιχτός Γκρίζος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.light_gray_terracotta": "Ανοιχτή Γκρίζα Τερακότα",
  "block.minecraft.light_gray_wool": "Ανοιχτό Γκρίζο Μαλλί",
  "block.minecraft.light_weighted_pressure_plate": "Πλάκα Πίεσης Μικρού Βάρους",
  "block.minecraft.lightning_rod": "Αλεξικέραυνο",
  "block.minecraft.lilac": "Πασχαλιά",
  "block.minecraft.lily_of_the_valley": "Κρίνος της Κοιλάδας",
  "block.minecraft.lily_pad": "Νούφαρο",
  "block.minecraft.lime_banner": "Λαχανί Λάβαρο",
  "block.minecraft.lime_bed": "Λαχανί Κρεβάτι",
  "block.minecraft.lime_candle": "Λαχανί Κερί",
  "block.minecraft.lime_candle_cake": "Τούρτα με Λαχανί Κερί",
  "block.minecraft.lime_carpet": "Λαχανί Χαλί",
  "block.minecraft.lime_concrete": "Λαχανί Σκυρόδεμα",
  "block.minecraft.lime_concrete_powder": "Λαχανί Σκόνη Σκυροδέματος",
  "block.minecraft.lime_glazed_terracotta": "Λαχανί Γυαλισμένη Τερακότα",
  "block.minecraft.lime_shulker_box": "Λαχανί Κιβώτιο Σάλκερ",
  "block.minecraft.lime_stained_glass": "Λαχανί Χρωματισμένο Γυαλί",
  "block.minecraft.lime_stained_glass_pane": "Λαχανί Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.lime_terracotta": "Λαχανί Τερακότα",
  "block.minecraft.lime_wool": "Λαχανί Μαλλί",
  "block.minecraft.lodestone": "Μαγνητίτης",
  "block.minecraft.loom": "Αργαλειός",
  "block.minecraft.magenta_banner": "Φούξια Λάβαρο",
  "block.minecraft.magenta_bed": "Φούξια Κρεβάτι",
  "block.minecraft.magenta_candle": "Φούξια Κερί",
  "block.minecraft.magenta_candle_cake": "Τούρτα με Φούξια Κερί",
  "block.minecraft.magenta_carpet": "Φούξια Χαλί",
  "block.minecraft.magenta_concrete": "Φούξια Σκυρόδεμα",
  "block.minecraft.magenta_concrete_powder": "Φούξια Σκόνη Σκυροδέματος",
  "block.minecraft.magenta_glazed_terracotta": "Φούξια Γυαλισμένη Τερακότα",
  "block.minecraft.magenta_shulker_box": "Φούξια Κιβώτιο Σάλκερ",
  "block.minecraft.magenta_stained_glass": "Φούξια Χρωματισμένο Γυαλί",
  "block.minecraft.magenta_stained_glass_pane": "Φούξια Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.magenta_terracotta": "Φούξια Τερακότα",
  "block.minecraft.magenta_wool": "Φούξια Μαλλί",
  "block.minecraft.magma_block": "Κύβος Μάγματος",
  "block.minecraft.mangrove_button": "Κουμπί Μαγκροβίου",
  "block.minecraft.mangrove_door": "Πόρτα Μαγκροβίου",
  "block.minecraft.mangrove_fence": "Φράχτης Μαγκροβίου",
  "block.minecraft.mangrove_fence_gate": "Πύλη Φράχτη Μαγκροβίου",
  "block.minecraft.mangrove_hanging_sign": "Κρεμαστή Πινακίδα Μαγκροβίου",
  "block.minecraft.mangrove_leaves": "Φύλλα Μαγκροβίου",
  "block.minecraft.mangrove_log": "Κορμός Μαγκροβίου",
  "block.minecraft.mangrove_planks": "Σανίδες Μαγκροβίου",
  "block.minecraft.mangrove_pressure_plate": "Πλάκα Πίεσης Μαγκροβίου",
  "block.minecraft.mangrove_propagule": "Κλωνίο Μαγκροβίου",
  "block.minecraft.mangrove_roots": "Ρίζες Μαγκροβίου",
  "block.minecraft.mangrove_shelf": "Ράφι Μαγκροβίου",
  "block.minecraft.mangrove_sign": "Πινακίδα Μαγκροβίου",
  "block.minecraft.mangrove_slab": "Πλάκα Μαγκροβίου",
  "block.minecraft.mangrove_stairs": "Σκάλες Μαγκροβίου",
  "block.minecraft.mangrove_trapdoor": "Καταπακτή Μαγκροβίου",
  "block.minecraft.mangrove_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Μαγκροβίου",
  "block.minecraft.mangrove_wall_sign": "Πινακίδα Τοίχου Μαγκροβίου",
  "block.minecraft.mangrove_wood": "Ξύλο Μαγκροβίου",
  "block.minecraft.medium_amethyst_bud": "Μεσαίο Μπουμπούκι Αμέθυστου",
  "block.minecraft.melon": "Καρπούζι",
  "block.minecraft.melon_stem": "Βλαστός Καρπουζιού",
  "block.minecraft.moss_block": "Κύβος Βρύων",
  "block.minecraft.moss_carpet": "Στρώμα Βρύων",
  "block.minecraft.mossy_cobblestone": "Βρυώδης Κροκάλα",
  "block.minecraft.mossy_cobblestone_slab": "Πλάκα Βρυώδους Κροκάλας",
  "block.minecraft.mossy_cobblestone_stairs": "Σκάλες Βρυώδους Κροκάλας",
  "block.minecraft.mossy_cobblestone_wall": "Τοίχος Βρυώδους Κροκάλας",
  "block.minecraft.mossy_stone_brick_slab": "Πλάκα Βρυωδών Τούβλων Πέτρας",
  "block.minecraft.mossy_stone_brick_stairs": "Σκάλες Βρυωδών Τούβλων Πέτρας",
  "block.minecraft.mossy_stone_brick_wall": "Τοίχος Βρυωδών Τούβλων Πέτρας",
  "block.minecraft.mossy_stone_bricks": "Βρυώδη Τούβλα Πέτρας",
  "block.minecraft.moving_piston": "Κινούμενο Έμβολο",
  "block.minecraft.mud": "Λάσπη",
  "block.minecraft.mud_brick_slab": "Πλάκα Τούβλων Λάσπης",
  "block.minecraft.mud_brick_stairs": "Σκάλες Τούβλων Λάσπης",
  "block.minecraft.mud_brick_wall": "Τοίχος Τούβλων Λάσπης",
  "block.minecraft.mud_bricks": "Τούβλα Λάσπης",
  "block.minecraft.muddy_mangrove_roots": "Λασπωμένες Ρίζες Μαγκροβίου",
  "block.minecraft.mushroom_stem": "Βλαστός Μανιταριού",
  "block.minecraft.mycelium": "Μυκήλιο",
  "block.minecraft.nether_brick_fence": "Φράχτης Τούβλων Νέδερ",
  "block.minecraft.nether_brick_slab": "Πλάκα Τούβλων Νέδερ",
  "block.minecraft.nether_brick_stairs": "Σκάλες Τούβλων Νέδερ",
  "block.minecraft.nether_brick_wall": "Τοίχος Τούβλων Νέδερ",
  "block.minecraft.nether_bricks": "Τούβλα Νέδερ",
  "block.minecraft.nether_gold_ore": "Μετάλλευμα Χρυσού Νέδερ",
  "block.minecraft.nether_portal": "Πύλη Νέδερ",
  "block.minecraft.nether_quartz_ore": "Μετάλλευμα Χαλαζία Νέδερ",
  "block.minecraft.nether_sprouts": "Βλαστάρια Νέδερ",
  "block.minecraft.nether_wart": "Στίγμα Νέδερ",
  "block.minecraft.nether_wart_block": "Κύβος Στίγματος Νέδερ",
  "block.minecraft.netherite_block": "Κύβος Νεδερίτη",
  "block.minecraft.netherrack": "Νέδερακ",
  "block.minecraft.note_block": "Κύβος Νότας",
  "block.minecraft.oak_button": "Κουμπί Βελανιδιάς",
  "block.minecraft.oak_door": "Πόρτα Βελανιδιάς",
  "block.minecraft.oak_fence": "Φράχτης Βελανιδιάς",
  "block.minecraft.oak_fence_gate": "Πύλη Φράχτη Βελανιδιάς",
  "block.minecraft.oak_hanging_sign": "Κρεμαστή Πινακίδα Βελανιδιάς",
  "block.minecraft.oak_leaves": "Φύλλα Βελανιδιάς",
  "block.minecraft.oak_log": "Κορμός Βελανιδιάς",
  "block.minecraft.oak_planks": "Σανίδες Βελανιδιάς",
  "block.minecraft.oak_pressure_plate": "Πλάκα Πίεσης Βελανιδιάς",
  "block.minecraft.oak_sapling": "Βλαστάρι Βελανιδιάς",
  "block.minecraft.oak_shelf": "Ράφι Βελανιδιάς",
  "block.minecraft.oak_sign": "Πινακίδα Βελανιδιάς",
  "block.minecraft.oak_slab": "Πλάκα Βελανιδιάς",
  "block.minecraft.oak_stairs": "Σκάλες Βελανιδιάς",
  "block.minecraft.oak_trapdoor": "Καταπακτή Βελανιδιάς",
  "block.minecraft.oak_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Βελανιδιάς",
  "block.minecraft.oak_wall_sign": "Πινακίδα Τοίχου Βελανιδιάς",
  "block.minecraft.oak_wood": "Ξύλο Βελανιδιάς",
  "block.minecraft.observer": "Παρατηρητής",
  "block.minecraft.obsidian": "Οψιδιανός",
  "block.minecraft.ochre_froglight": "Ωχρό Βατραχόφως",
  "block.minecraft.ominous_banner": "Δυσοίωνο Λάβαρο",
  "block.minecraft.open_eyeblossom": "Ανοιχτός Οφθάλμανθος",
  "block.minecraft.orange_banner": "Πορτοκαλί Λάβαρο",
  "block.minecraft.orange_bed": "Πορτοκαλί Κρεβάτι",
  "block.minecraft.orange_candle": "Πορτοκαλί Κερί",
  "block.minecraft.orange_candle_cake": "Τούρτα με Πορτοκαλί Κερί",
  "block.minecraft.orange_carpet": "Πορτοκαλί Χαλί",
  "block.minecraft.orange_concrete": "Πορτοκαλί Σκυρόδεμα",
  "block.minecraft.orange_concrete_powder": "Πορτοκαλί Σκόνη Σκυροδέματος",
  "block.minecraft.orange_glazed_terracotta": "Πορτοκαλί Γυαλισμένη Τερακότα",
  "block.minecraft.orange_shulker_box": "Πορτοκαλί Κιβώτιο Σάλκερ",
  "block.minecraft.orange_stained_glass": "Πορτοκαλί Χρωματισμένο Γυαλί",
  "block.minecraft.orange_stained_glass_pane": "Πορτοκαλί Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.orange_terracotta": "Πορτοκαλί Τερακότα",
  "block.minecraft.orange_tulip": "Πορτοκαλί Τουλίπα",
  "block.minecraft.orange_wool": "Πορτοκαλί Μαλλί",
  "block.minecraft.oxeye_daisy": "Μαργαρίτα",
  "block.minecraft.oxidized_chiseled_copper": "Οξειδωμένος Λαξευμένος Χαλκός",
  "block.minecraft.oxidized_copper": "Οξειδωμένος Χαλκός",
  "block.minecraft.oxidized_copper_bars": "Κάγκελα Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_bulb": "Λάμπα Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_chain": "Αλυσίδα Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_chest": "Σεντούκι Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_door": "Πόρτα Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_golem_statue": "Άγαλμα Γκόλεμ Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_grate": "Σχάρα Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_lantern": "Φανάρι Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_copper_trapdoor": "Καταπακτή Οξειδωμένου Χαλκού",
  "block.minecraft.oxidized_cut_copper": "Οξειδωμένος Κομμένος Χαλκός",
  "block.minecraft.oxidized_cut_copper_slab": "Πλάκα Οξειδωμένου Κομμένου Χαλκού",
  "block.minecraft.oxidized_cut_copper_stairs": "Σκάλες Οξειδωμένου Κομμένου Χαλκού",
  "block.minecraft.oxidized_lightning_rod": "Οξειδωμένο Αλεξικέραυνο",
  "block.minecraft.packed_ice": "Συμπιεσμένος Πάγος",
  "block.minecraft.packed_mud": "Συμπιεσμένη Λάσπη",
  "block.minecraft.pale_hanging_moss": "Λευκά Κρεμαστά Βρύα",
  "block.minecraft.pale_moss_block": "Κύβος Λευκών Βρύων",
  "block.minecraft.pale_moss_carpet": "Στρώμα Λευκών Βρύων",
  "block.minecraft.pale_oak_button": "Κουμπί Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_door": "Πόρτα Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_fence": "Φράχτης Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_fence_gate": "Πύλη Φράχτη Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_hanging_sign": "Κρεμαστή Πινακίδα Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_leaves": "Φύλλα Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_log": "Κορμός Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_planks": "Σανίδες Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_pressure_plate": "Πλάκα Πίεσης Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_sapling": "Βλαστάρι Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_shelf": "Ράφι Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_sign": "Πινακίδα Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_slab": "Πλάκα Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_stairs": "Σκάλες Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_trapdoor": "Καταπακτή Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_wall_sign": "Πινακίδα Τοίχου Λευκής Βελανιδιάς",
  "block.minecraft.pale_oak_wood": "Ξύλο Λευκής Βελανιδιάς",
  "block.minecraft.pearlescent_froglight": "Μαργαρώδες Βατραχόφως",
  "block.minecraft.peony": "Παιώνια",
  "block.minecraft.petrified_oak_slab": "Πλάκα Απολιθωμένης Βελανιδιάς",
  "block.minecraft.piglin_head": "Κεφάλι Πίγκλιν",
  "block.minecraft.piglin_wall_head": "Κεφάλι Τοίχου Πίγκλιν",
  "block.minecraft.pink_banner": "Ροζ Λάβαρο",
  "block.minecraft.pink_bed": "Ροζ Κρεβάτι",
  "block.minecraft.pink_candle": "Ροζ Κερί",
  "block.minecraft.pink_candle_cake": "Τούρτα με Ροζ Κερί",
  "block.minecraft.pink_carpet": "Ροζ Χαλί",
  "block.minecraft.pink_concrete": "Ροζ Σκυρόδεμα",
  "block.minecraft.pink_concrete_powder": "Ροζ Σκόνη Σκυροδέματος",
  "block.minecraft.pink_glazed_terracotta": "Ροζ Γυαλισμένη Τερακότα",
  "block.minecraft.pink_petals": "Ροζ Πέταλα",
  "block.minecraft.pink_shulker_box": "Ροζ Κιβώτιο Σάλκερ",
  "block.minecraft.pink_stained_glass": "Ροζ Χρωματισμένο Γυαλί",
  "block.minecraft.pink_stained_glass_pane": "Ροζ Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.pink_terracotta": "Ροζ Τερακότα",
  "block.minecraft.pink_tulip": "Ροζ Τουλίπα",
  "block.minecraft.pink_wool": "Ροζ Μαλλί",
  "block.minecraft.piston": "Έμβολο",
  "block.minecraft.piston_head": "Κεφαλή Εμβόλου",
  "block.minecraft.pitcher_crop": "Καλλιέργεια Νηπενθούς",
  "block.minecraft.pitcher_plant": "Φυτό Νηπενθούς",
  "block.minecraft.player_head": "Κεφάλι Παίκτη",
  "block.minecraft.player_head.named": "Κεφάλι του παίκτη %s",
  "block.minecraft.player_wall_head": "Κεφάλι Τοίχου Παίκτη",
  "block.minecraft.podzol": "Ποντσόλ",
  "block.minecraft.pointed_dripstone": "Αιχμηρή Σταλόπετρα",
  "block.minecraft.polished_andesite": "Γυαλισμένος Ανδεσίτης",
  "block.minecraft.polished_andesite_slab": "Πλάκα Γυαλισμένου Ανδεσίτη",
  "block.minecraft.polished_andesite_stairs": "Σκάλες Γυαλισμένου Ανδεσίτη",
  "block.minecraft.polished_basalt": "Γυαλισμένος Βασάλτης",
  "block.minecraft.polished_blackstone": "Γυαλισμένη Μαυρόπετρα",
  "block.minecraft.polished_blackstone_brick_slab": "Πλάκα Γυαλισμένων Τούβλων Μαυρόπετρας",
  "block.minecraft.polished_blackstone_brick_stairs": "Σκάλες Γυαλισμένων Τούβλων Μαυρόπετρας",
  "block.minecraft.polished_blackstone_brick_wall": "Τοίχος Γυαλισμένων Τούβλων Μαυρόπετρας",
  "block.minecraft.polished_blackstone_bricks": "Γυαλισμένα Τούβλα Μαυρόπετρας",
  "block.minecraft.polished_blackstone_button": "Κουμπί Γυαλισμένης Μαυρόπετρας",
  "block.minecraft.polished_blackstone_pressure_plate": "Πλάκα Πίεσης Γυαλισμένης Μαυρόπετρας",
  "block.minecraft.polished_blackstone_slab": "Πλάκα Γυαλισμένης Μαυρόπετρας",
  "block.minecraft.polished_blackstone_stairs": "Σκάλες Γυαλισμένης Μαυρόπετρας",
  "block.minecraft.polished_blackstone_wall": "Τοίχος Γυαλισμένης Μαυρόπετρας",
  "block.minecraft.polished_deepslate": "Γυαλισμένος Βαθόλιθος",
  "block.minecraft.polished_deepslate_slab": "Πλάκα Γυαλισμένου Βαθόλιθου",
  "block.minecraft.polished_deepslate_stairs": "Σκάλες Γυαλισμένου Βαθόλιθου",
  "block.minecraft.polished_deepslate_wall": "Τοίχος Γυαλισμένου Βαθόλιθου",
  "block.minecraft.polished_diorite": "Γυαλισμένος Διορίτης",
  "block.minecraft.polished_diorite_slab": "Πλάκα Γυαλισμένου Διορίτη",
  "block.minecraft.polished_diorite_stairs": "Σκάλες Γυαλισμένου Διορίτη",
  "block.minecraft.polished_granite": "Γυαλισμένος Γρανίτης",
  "block.minecraft.polished_granite_slab": "Πλάκα Γυαλισμένου Γρανίτη",
  "block.minecraft.polished_granite_stairs": "Σκάλες Γυαλισμένου Γρανίτη",
  "block.minecraft.polished_tuff": "Γυαλισμένος Τόφος",
  "block.minecraft.polished_tuff_slab": "Πλάκα Γυαλισμένου Τόφου",
  "block.minecraft.polished_tuff_stairs": "Σκάλες Γυαλισμένου Τόφου",
  "block.minecraft.polished_tuff_wall": "Τοίχος Γυαλισμένου Τόφου",
  "block.minecraft.poppy": "Παπαρούνα",
  "block.minecraft.potatoes": "Πατάτες",
  "block.minecraft.potted_acacia_sapling": "Βλαστάρι Ακακίας σε Γλάστρα",
  "block.minecraft.potted_allium": "Άλλιο σε Γλάστρα",
  "block.minecraft.potted_azalea_bush": "Αζαλέα σε Γλάστρα",
  "block.minecraft.potted_azure_bluet": "Αζουριά σε Γλάστρα",
  "block.minecraft.potted_bamboo": "Μπαμπού σε Γλάστρα",
  "block.minecraft.potted_birch_sapling": "Βλαστάρι Σημύδας σε Γλάστρα",
  "block.minecraft.potted_blue_orchid": "Γαλάζια Ορχιδέα σε Γλάστρα",
  "block.minecraft.potted_brown_mushroom": "Καφέ Μανιτάρι σε Γλάστρα",
  "block.minecraft.potted_cactus": "Κάκτος σε Γλάστρα",
  "block.minecraft.potted_cherry_sapling": "Βλαστάρι Κερασιάς σε Γλάστρα",
  "block.minecraft.potted_closed_eyeblossom": "Κλειστός Οφθάλμανθος σε Γλάστρα",
  "block.minecraft.potted_cornflower": "Κενταύρια σε Γλάστρα",
  "block.minecraft.potted_crimson_fungus": "Ερυθρός Μύκητας σε Γλάστρα",
  "block.minecraft.potted_crimson_roots": "Ερυθρές Ρίζες σε Γλάστρα",
  "block.minecraft.potted_dandelion": "Πικραλίδα σε Γλάστρα",
  "block.minecraft.potted_dark_oak_sapling": "Βλαστάρι Σκούρας Βελανιδιάς σε Γλάστρα",
  "block.minecraft.potted_dead_bush": "Ξερός Θάμνος σε Γλάστρα",
  "block.minecraft.potted_fern": "Φτέρη σε Γλάστρα",
  "block.minecraft.potted_flowering_azalea_bush": "Ανθισμένη Αζαλέα σε Γλάστρα",
  "block.minecraft.potted_golden_dandelion": "Χρυσή Πικραλίδα σε Γλάστρα",
  "block.minecraft.potted_jungle_sapling": "Βλαστάρι Ζούγκλας σε Γλάστρα",
  "block.minecraft.potted_lily_of_the_valley": "Κρίνος της Κοιλάδας σε Γλάστρα",
  "block.minecraft.potted_mangrove_propagule": "Κλωνίο Μαγκροβίου σε Γλάστρα",
  "block.minecraft.potted_oak_sapling": "Βλαστάρι Βελανιδιάς σε Γλάστρα",
  "block.minecraft.potted_open_eyeblossom": "Ανοιχτός Οφθάλμανθος σε Γλάστρα",
  "block.minecraft.potted_orange_tulip": "Πορτοκαλί Τουλίπα σε Γλάστρα",
  "block.minecraft.potted_oxeye_daisy": "Μαργαρίτα σε Γλάστρα",
  "block.minecraft.potted_pale_oak_sapling": "Βλαστάρι Λευκής Βελανιδιάς σε Γλάστρα",
  "block.minecraft.potted_pink_tulip": "Ροζ Τουλίπα σε Γλάστρα",
  "block.minecraft.potted_poppy": "Παπαρούνα σε Γλάστρα",
  "block.minecraft.potted_red_mushroom": "Κόκκινο Μανιτάρι σε Γλάστρα",
  "block.minecraft.potted_red_tulip": "Κόκκινη Τουλίπα σε Γλάστρα",
  "block.minecraft.potted_spruce_sapling": "Βλαστάρι Ελάτου σε Γλάστρα",
  "block.minecraft.potted_torchflower": "Πύρσανθος σε Γλάστρα",
  "block.minecraft.potted_warped_fungus": "Στρεβλωμένος Μύκητας σε Γλάστρα",
  "block.minecraft.potted_warped_roots": "Στρεβλωμένες Ρίζες σε Γλάστρα",
  "block.minecraft.potted_white_tulip": "Λευκή Τουλίπα σε Γλάστρα",
  "block.minecraft.potted_wither_rose": "Τριαντάφυλλο Ουίδερ σε Γλάστρα",
  "block.minecraft.powder_snow": "Φρέσκο Χιόνι",
  "block.minecraft.powder_snow_cauldron": "Καζάνι Φρέσκου Χιονιού",
  "block.minecraft.powered_rail": "Τροφοδοτούμενη Ράγα",
  "block.minecraft.prismarine": "Πρισμαρίνη",
  "block.minecraft.prismarine_brick_slab": "Πλάκα Τούβλων Πρισμαρίνης",
  "block.minecraft.prismarine_brick_stairs": "Σκάλες Τούβλων Πρισμαρίνης",
  "block.minecraft.prismarine_bricks": "Τούβλα Πρισμαρίνης",
  "block.minecraft.prismarine_slab": "Πλάκα Πρισμαρίνης",
  "block.minecraft.prismarine_stairs": "Σκάλες Πρισμαρίνης",
  "block.minecraft.prismarine_wall": "Τοίχος Πρισμαρίνης",
  "block.minecraft.pumpkin": "Κολοκύθα",
  "block.minecraft.pumpkin_stem": "Βλαστός Κολοκύθας",
  "block.minecraft.purple_banner": "Μοβ Λάβαρο",
  "block.minecraft.purple_bed": "Μοβ Κρεβάτι",
  "block.minecraft.purple_candle": "Μοβ Κερί",
  "block.minecraft.purple_candle_cake": "Τούρτα με Μοβ Κερί",
  "block.minecraft.purple_carpet": "Μοβ Χαλί",
  "block.minecraft.purple_concrete": "Μοβ Σκυρόδεμα",
  "block.minecraft.purple_concrete_powder": "Μοβ Σκόνη Σκυροδέματος",
  "block.minecraft.purple_glazed_terracotta": "Μοβ Γυαλισμένη Τερακότα",
  "block.minecraft.purple_shulker_box": "Μοβ Κιβώτιο Σάλκερ",
  "block.minecraft.purple_stained_glass": "Μοβ Χρωματισμένο Γυαλί",
  "block.minecraft.purple_stained_glass_pane": "Μοβ Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.purple_terracotta": "Μοβ Τερακότα",
  "block.minecraft.purple_wool": "Μοβ Μαλλί",
  "block.minecraft.purpur_block": "Κύβος Πέρπουρ",
  "block.minecraft.purpur_pillar": "Στήλη Πέρπουρ",
  "block.minecraft.purpur_slab": "Πλάκα Πέρπουρ",
  "block.minecraft.purpur_stairs": "Σκάλες Πέρπουρ",
  "block.minecraft.quartz_block": "Κύβος Χαλαζία",
  "block.minecraft.quartz_bricks": "Τούβλα Χαλαζία",
  "block.minecraft.quartz_pillar": "Στήλη Χαλαζία",
  "block.minecraft.quartz_slab": "Πλάκα Χαλαζία",
  "block.minecraft.quartz_stairs": "Σκάλες Χαλαζία",
  "block.minecraft.rail": "Ράγα",
  "block.minecraft.raw_copper_block": "Κύβος Ακατέργαστου Χαλκού",
  "block.minecraft.raw_gold_block": "Κύβος Ακατέργαστου Χρυσού",
  "block.minecraft.raw_iron_block": "Κύβος Ακατέργαστου Σιδήρου",
  "block.minecraft.red_banner": "Κόκκινο Λάβαρο",
  "block.minecraft.red_bed": "Κόκκινο Κρεβάτι",
  "block.minecraft.red_candle": "Κόκκινο Κερί",
  "block.minecraft.red_candle_cake": "Τούρτα με Κόκκινο Κερί",
  "block.minecraft.red_carpet": "Κόκκινο Χαλί",
  "block.minecraft.red_concrete": "Κόκκινο Σκυρόδεμα",
  "block.minecraft.red_concrete_powder": "Κόκκινη Σκόνη Σκυροδέματος",
  "block.minecraft.red_glazed_terracotta": "Κόκκινη Γυαλισμένη Τερακότα",
  "block.minecraft.red_mushroom": "Κόκκινο Μανιτάρι",
  "block.minecraft.red_mushroom_block": "Κύβος Κόκκινου Μανιταριού",
  "block.minecraft.red_nether_brick_slab": "Πλάκα Κόκκινων Τούβλων Νέδερ",
  "block.minecraft.red_nether_brick_stairs": "Σκάλες Κόκκινων Τούβλων Νέδερ",
  "block.minecraft.red_nether_brick_wall": "Τοίχος Κόκκινων Τούβλων Νέδερ",
  "block.minecraft.red_nether_bricks": "Κόκκινα Τούβλα Νέδερ",
  "block.minecraft.red_sand": "Κόκκινη Άμμος",
  "block.minecraft.red_sandstone": "Κόκκινη Αμμόπετρα",
  "block.minecraft.red_sandstone_slab": "Πλάκα Κόκκινης Αμμόπετρας",
  "block.minecraft.red_sandstone_stairs": "Σκάλες Κόκκινης Αμμόπετρας",
  "block.minecraft.red_sandstone_wall": "Τοίχος Κόκκινης Αμμόπετρας",
  "block.minecraft.red_shulker_box": "Κόκκινο Κιβώτιο Σάλκερ",
  "block.minecraft.red_stained_glass": "Κόκκινο Χρωματισμένο Γυαλί",
  "block.minecraft.red_stained_glass_pane": "Κόκκινος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.red_terracotta": "Κόκκινη Τερακότα",
  "block.minecraft.red_tulip": "Κόκκινη Τουλίπα",
  "block.minecraft.red_wool": "Κόκκινο Μαλλί",
  "block.minecraft.redstone_block": "Κύβος Ρέντστοουν",
  "block.minecraft.redstone_lamp": "Λάμπα Ρέντστοουν",
  "block.minecraft.redstone_ore": "Μετάλλευμα Ρέντστοουν",
  "block.minecraft.redstone_torch": "Πυρσός Ρέντστοουν",
  "block.minecraft.redstone_wall_torch": "Πυρσός Τοίχου Ρέντστοουν",
  "block.minecraft.redstone_wire": "Σύρμα Ρέντστοουν",
  "block.minecraft.reinforced_deepslate": "Ενισχυμένος Βαθόλιθος",
  "block.minecraft.repeater": "Αναμεταδότης Ρέντστοουν",
  "block.minecraft.repeating_command_block": "Κύβος Εντολής Επανάληψης",
  "block.minecraft.resin_block": "Κύβος Ρητίνης",
  "block.minecraft.resin_brick_slab": "Πλάκα Τούβλων Ρητίνης",
  "block.minecraft.resin_brick_stairs": "Σκάλες Τούβλων Ρητίνης",
  "block.minecraft.resin_brick_wall": "Τοίχος Τούβλων Ρητίνης",
  "block.minecraft.resin_bricks": "Τούβλα Ρητίνης",
  "block.minecraft.resin_clump": "Συστάδα Ρητίνης",
  "block.minecraft.respawn_anchor": "Άγκυρα Αναγέννησης",
  "block.minecraft.rooted_dirt": "Ριζωμένο Χώμα",
  "block.minecraft.rose_bush": "Θάμνος Τριαντάφυλλων",
  "block.minecraft.sand": "Άμμος",
  "block.minecraft.sandstone": "Αμμόπετρα",
  "block.minecraft.sandstone_slab": "Πλάκα Αμμόπετρας",
  "block.minecraft.sandstone_stairs": "Σκάλες Αμμόπετρας",
  "block.minecraft.sandstone_wall": "Τοίχος Αμμόπετρας",
  "block.minecraft.scaffolding": "Σκαλωσιά",
  "block.minecraft.sculk": "Σκαλκ",
  "block.minecraft.sculk_catalyst": "Καταλύτης Σκαλκ",
  "block.minecraft.sculk_sensor": "Αισθητήρας Σκαλκ",
  "block.minecraft.sculk_shrieker": "Κράχτης Σκαλκ",
  "block.minecraft.sculk_vein": "Φλέβα Σκαλκ",
  "block.minecraft.sea_lantern": "Θαλάσσιο Φανάρι",
  "block.minecraft.sea_pickle": "Θαλάσσιο Τουρσί",
  "block.minecraft.seagrass": "Θαλάσσιο Γρασίδι",
  "block.minecraft.set_spawn": "Σημείο αναγέννησης τέθηκε",
  "block.minecraft.short_dry_grass": "Κοντό Ξερό Γρασίδι",
  "block.minecraft.short_grass": "Κοντό Γρασίδι",
  "block.minecraft.shroomlight": "Μανιταρόφως",
  "block.minecraft.shulker_box": "Κιβώτιο Σάλκερ",
  "block.minecraft.skeleton_skull": "Κρανίο Σκελετού",
  "block.minecraft.skeleton_wall_skull": "Κρανίο Τοίχου Σκελετού",
  "block.minecraft.slime_block": "Κύβος Γλίτσας",
  "block.minecraft.small_amethyst_bud": "Μικρό Μπουμπούκι Αμέθυστου",
  "block.minecraft.small_dripleaf": "Μικρό Σταλόφυλλο",
  "block.minecraft.smithing_table": "Τραπέζι Μεταλλουργίας",
  "block.minecraft.smoker": "Καπνιστήρι",
  "block.minecraft.smooth_basalt": "Λείος Βασάλτης",
  "block.minecraft.smooth_quartz": "Κύβος Λείου Χαλαζία",
  "block.minecraft.smooth_quartz_slab": "Πλάκα Λείου Χαλαζία",
  "block.minecraft.smooth_quartz_stairs": "Σκάλες Λείου Χαλαζία",
  "block.minecraft.smooth_red_sandstone": "Λεία Κόκκινη Αμμόπετρα",
  "block.minecraft.smooth_red_sandstone_slab": "Πλάκα Λείας Κόκκινης Αμμόπετρας",
  "block.minecraft.smooth_red_sandstone_stairs": "Σκάλες Λείας Κόκκινης Αμμόπετρας",
  "block.minecraft.smooth_sandstone": "Λεία Αμμόπετρα",
  "block.minecraft.smooth_sandstone_slab": "Πλάκα Λείας Αμμόπετρας",
  "block.minecraft.smooth_sandstone_stairs": "Σκάλες Λείας Αμμόπετρας",
  "block.minecraft.smooth_stone": "Λεία Πέτρα",
  "block.minecraft.smooth_stone_slab": "Πλάκα Λείας Πέτρας",
  "block.minecraft.sniffer_egg": "Αβγό Οσφρητή",
  "block.minecraft.snow": "Χιόνι",
  "block.minecraft.snow_block": "Κύβος Χιονιού",
  "block.minecraft.soul_campfire": "Φωτιά Κατασκήνωσης Ψυχών",
  "block.minecraft.soul_fire": "Φωτιά Ψυχών",
  "block.minecraft.soul_lantern": "Φανάρι Ψυχών",
  "block.minecraft.soul_sand": "Άμμος Ψυχών",
  "block.minecraft.soul_soil": "Χώμα Ψυχών",
  "block.minecraft.soul_torch": "Πυρσός Ψυχών",
  "block.minecraft.soul_wall_torch": "Πυρσός Τοίχου Ψυχών",
  "block.minecraft.spawn.not_valid": "Δεν έχεις κρεβάτι ή φορτισμένη άγκυρα αναγέννησης, ή ήταν παρεμποδισμένα",
  "block.minecraft.spawner": "Γεννήτρια Τεράτων",
  "block.minecraft.spawner.desc1": "Χρήση με Αβγό Γέννησης:",
  "block.minecraft.spawner.desc2": "Θέτει Τύπο Όντος",
  "block.minecraft.sponge": "Σφουγγάρι",
  "block.minecraft.spore_blossom": "Άνθος Σπόρων",
  "block.minecraft.spruce_button": "Κουμπί Ελάτου",
  "block.minecraft.spruce_door": "Πόρτα Ελάτου",
  "block.minecraft.spruce_fence": "Φράχτης Ελάτου",
  "block.minecraft.spruce_fence_gate": "Πύλη Φράχτη Ελάτου",
  "block.minecraft.spruce_hanging_sign": "Κρεμαστή Πινακίδα Ελάτου",
  "block.minecraft.spruce_leaves": "Φύλλα Ελάτου",
  "block.minecraft.spruce_log": "Κορμός Ελάτου",
  "block.minecraft.spruce_planks": "Σανίδες Ελάτου",
  "block.minecraft.spruce_pressure_plate": "Πλάκα Πίεσης Ελάτου",
  "block.minecraft.spruce_sapling": "Βλαστάρι Ελάτου",
  "block.minecraft.spruce_shelf": "Ράφι Ελάτου",
  "block.minecraft.spruce_sign": "Πινακίδα Ελάτου",
  "block.minecraft.spruce_slab": "Πλάκα Ελάτου",
  "block.minecraft.spruce_stairs": "Σκάλες Ελάτου",
  "block.minecraft.spruce_trapdoor": "Καταπακτή Ελάτου",
  "block.minecraft.spruce_wall_hanging_sign": "Κρεμαστή Πινακίδα Τοίχου Ελάτου",
  "block.minecraft.spruce_wall_sign": "Πινακίδα Τοίχου Ελάτου",
  "block.minecraft.spruce_wood": "Ξύλο Ελάτου",
  "block.minecraft.sticky_piston": "Κολλώδες Έμβολο",
  "block.minecraft.stone": "Πέτρα",
  "block.minecraft.stone_brick_slab": "Πλάκα Τούβλων Πέτρας",
  "block.minecraft.stone_brick_stairs": "Σκάλες Τούβλων Πέτρας",
  "block.minecraft.stone_brick_wall": "Τοίχος Τούβλων Πέτρας",
  "block.minecraft.stone_bricks": "Τούβλα Πέτρας",
  "block.minecraft.stone_button": "Κουμπί Πέτρας",
  "block.minecraft.stone_pressure_plate": "Πλάκα Πίεσης Πέτρας",
  "block.minecraft.stone_slab": "Πλάκα Πέτρας",
  "block.minecraft.stone_stairs": "Σκάλες Πέτρας",
  "block.minecraft.stonecutter": "Πετροκόπτης",
  "block.minecraft.stripped_acacia_log": "Αποφλοιωμένος Κορμός Ακακίας",
  "block.minecraft.stripped_acacia_wood": "Αποφλοιωμένο Ξύλο Ακακίας",
  "block.minecraft.stripped_bamboo_block": "Κύβος Αποφλοιωμένου Μπαμπού",
  "block.minecraft.stripped_birch_log": "Αποφλοιωμένος Κορμός Σημύδας",
  "block.minecraft.stripped_birch_wood": "Αποφλοιωμένο Ξύλο Σημύδας",
  "block.minecraft.stripped_cherry_log": "Αποφλοιωμένος Κορμός Κερασιάς",
  "block.minecraft.stripped_cherry_wood": "Αποφλοιωμένο Ξύλο Κερασιάς",
  "block.minecraft.stripped_crimson_hyphae": "Αποφλοιωμένες Ερυθρές Υφές",
  "block.minecraft.stripped_crimson_stem": "Αποφλοιωμένος Ερυθρός Βλαστός",
  "block.minecraft.stripped_dark_oak_log": "Αποφλοιωμένος Κορμός Σκούρας Βελανιδιάς",
  "block.minecraft.stripped_dark_oak_wood": "Αποφλοιωμένο Ξύλο Σκούρας Βελανιδιάς",
  "block.minecraft.stripped_jungle_log": "Αποφλοιωμένος Κορμός Ζούγκλας",
  "block.minecraft.stripped_jungle_wood": "Αποφλοιωμένο Ξύλο Ζούγκλας",
  "block.minecraft.stripped_mangrove_log": "Αποφλοιωμένος Κορμός Μαγκροβίου",
  "block.minecraft.stripped_mangrove_wood": "Αποφλοιωμένο Ξύλο Μαγκροβίου",
  "block.minecraft.stripped_oak_log": "Αποφλοιωμένος Κορμός Βελανιδιάς",
  "block.minecraft.stripped_oak_wood": "Αποφλοιωμένο Ξύλο Βελανιδιάς",
  "block.minecraft.stripped_pale_oak_log": "Αποφλοιωμένος Κορμός Λευκής Βελανιδιάς",
  "block.minecraft.stripped_pale_oak_wood": "Αποφλοιωμένο Ξύλο Λευκής Βελανιδιάς",
  "block.minecraft.stripped_spruce_log": "Αποφλοιωμένος Κορμός Ελάτου",
  "block.minecraft.stripped_spruce_wood": "Αποφλοιωμένο Ξύλο Ελάτου",
  "block.minecraft.stripped_warped_hyphae": "Αποφλοιωμένες Στρεβλωμένες Υφές",
  "block.minecraft.stripped_warped_stem": "Αποφλοιωμένος Στρεβλωμένος Βλαστός",
  "block.minecraft.structure_block": "Κύβος Δομής",
  "block.minecraft.structure_void": "Κενό Δομής",
  "block.minecraft.sugar_cane": "Ζαχαροκάλαμο",
  "block.minecraft.sunflower": "Ηλίανθος",
  "block.minecraft.suspicious_gravel": "Ύποπτο Χαλίκι",
  "block.minecraft.suspicious_sand": "Ύποπτη Άμμος",
  "block.minecraft.sweet_berry_bush": "Θάμνος Γλυκών Μούρων",
  "block.minecraft.tall_dry_grass": "Ψηλό Ξερό Γρασίδι",
  "block.minecraft.tall_grass": "Ψηλό Γρασίδι",
  "block.minecraft.tall_seagrass": "Ψηλό Θαλάσσιο Γρασίδι",
  "block.minecraft.target": "Στόχος",
  "block.minecraft.terracotta": "Τερακότα",
  "block.minecraft.test_block": "Κύβος Δοκιμής",
  "block.minecraft.test_instance_block": "Κύβος Παρουσίας Δοκιμής",
  "block.minecraft.tinted_glass": "Φιμέ Γυαλί",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Οι εκρήξεις TNT είναι απενεργοποιημένες",
  "block.minecraft.torch": "Πυρσός",
  "block.minecraft.torchflower": "Πύρσανθος",
  "block.minecraft.torchflower_crop": "Καλλιέργεια Πυρσάνθου",
  "block.minecraft.trapped_chest": "Σεντούκι Παγίδα",
  "block.minecraft.trial_spawner": "Γεννήτρια Δοκιμασίας",
  "block.minecraft.tripwire": "Πλέγμα Κλωστής",
  "block.minecraft.tripwire_hook": "Γάντζος Πλέγματος Κλωστής",
  "block.minecraft.tube_coral": "Μπλε Κοράλλι",
  "block.minecraft.tube_coral_block": "Κύβος Μπλε Κοραλλιού",
  "block.minecraft.tube_coral_fan": "Μπλε Αλκυονοειδές Κοράλλι",
  "block.minecraft.tube_coral_wall_fan": "Μπλε Αλκυονοειδές Κοράλλι Τοίχου",
  "block.minecraft.tuff": "Τόφος",
  "block.minecraft.tuff_brick_slab": "Πλάκα Τούβλων Τόφου",
  "block.minecraft.tuff_brick_stairs": "Σκάλες Τούβλων Τόφου",
  "block.minecraft.tuff_brick_wall": "Τοίχος Τούβλων Τόφου",
  "block.minecraft.tuff_bricks": "Τούβλα Τόφου",
  "block.minecraft.tuff_slab": "Πλάκα Τόφου",
  "block.minecraft.tuff_stairs": "Σκάλες Τόφου",
  "block.minecraft.tuff_wall": "Τοίχος Τόφου",
  "block.minecraft.turtle_egg": "Αβγό Χελώνας",
  "block.minecraft.twisting_vines": "Στριφογυριστές Κληματσίδες",
  "block.minecraft.twisting_vines_plant": "Φυτό Στριφογυριστών Κληματσίδων",
  "block.minecraft.vault": "Θησαυροφυλάκιο",
  "block.minecraft.verdant_froglight": "Χλοερό Βατραχόφως",
  "block.minecraft.vine": "Κληματσίδες",
  "block.minecraft.void_air": "Αέρας Κενού",
  "block.minecraft.wall_torch": "Πυρσός Τοίχου",
  "block.minecraft.warped_button": "Στρεβλωμένο Κουμπί",
  "block.minecraft.warped_door": "Στρεβλωμένη Πόρτα",
  "block.minecraft.warped_fence": "Στρεβλωμένος Φράχτης",
  "block.minecraft.warped_fence_gate": "Στρεβλωμένη Πύλη Φράχτη",
  "block.minecraft.warped_fungus": "Στρεβλωμένος Μύκητας",
  "block.minecraft.warped_hanging_sign": "Στρεβλωμένη Κρεμαστή Πινακίδα",
  "block.minecraft.warped_hyphae": "Στρεβλωμένες Υφές",
  "block.minecraft.warped_nylium": "Στρεβλωμένο Νύλιο",
  "block.minecraft.warped_planks": "Στρεβλωμένες Σανίδες",
  "block.minecraft.warped_pressure_plate": "Στρεβλωμένη Πλάκα Πίεσης",
  "block.minecraft.warped_roots": "Στρεβλωμένες Ρίζες",
  "block.minecraft.warped_shelf": "Στρεβλωμένο Ράφι",
  "block.minecraft.warped_sign": "Στρεβλωμένη Πινακίδα",
  "block.minecraft.warped_slab": "Στρεβλωμένη Πλάκα",
  "block.minecraft.warped_stairs": "Στρεβλωμένες Σκάλες",
  "block.minecraft.warped_stem": "Στρεβλωμένος Βλαστός",
  "block.minecraft.warped_trapdoor": "Στρεβλωμένη Καταπακτή",
  "block.minecraft.warped_wall_hanging_sign": "Στρεβλωμένη Κρεμαστή Πινακίδα Τοίχου",
  "block.minecraft.warped_wall_sign": "Στρεβλωμένη Πινακίδα Τοίχου",
  "block.minecraft.warped_wart_block": "Κύβος Στρεβλωμένου Στίγματος",
  "block.minecraft.water": "Νερό",
  "block.minecraft.water_cauldron": "Καζάνι Νερού",
  "block.minecraft.waxed_chiseled_copper": "Κερωμένος Λαξευμένος Χαλκός",
  "block.minecraft.waxed_copper_bars": "Κερωμένα Κάγκελα Χαλκού",
  "block.minecraft.waxed_copper_block": "Κερωμένος Κύβος Χαλκού",
  "block.minecraft.waxed_copper_bulb": "Κερωμένη Λάμπα Χαλκού",
  "block.minecraft.waxed_copper_chain": "Κερωμένη Αλυσίδα Χαλκού",
  "block.minecraft.waxed_copper_chest": "Κερωμένο Σεντούκι Χαλκού",
  "block.minecraft.waxed_copper_door": "Κερωμένη Πόρτα Χαλκού",
  "block.minecraft.waxed_copper_golem_statue": "Κερωμένο Άγαλμα Γκόλεμ Χαλκού",
  "block.minecraft.waxed_copper_grate": "Κερωμένη Σχάρα Χαλκού",
  "block.minecraft.waxed_copper_lantern": "Κερωμένο Φανάρι Χαλκού",
  "block.minecraft.waxed_copper_trapdoor": "Κερωμένη Καταπακτή Χαλκού",
  "block.minecraft.waxed_cut_copper": "Κερωμένος Κομμένος Χαλκός",
  "block.minecraft.waxed_cut_copper_slab": "Κερωμένη Πλάκα Κομμένου Χαλκού",
  "block.minecraft.waxed_cut_copper_stairs": "Κερωμένες Σκάλες Κομμένου Χαλκού",
  "block.minecraft.waxed_exposed_chiseled_copper": "Κερωμένος Εκτεθειμένος Λαξευμένος Χαλκός",
  "block.minecraft.waxed_exposed_copper": "Κερωμένος Εκτεθειμένος Χαλκός",
  "block.minecraft.waxed_exposed_copper_bars": "Κερωμένα Κάγκελα Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_bulb": "Κερωμένη Λάμπα Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_chain": "Κερωμένη Αλυσίδα Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_chest": "Κερωμένο Σεντούκι Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_door": "Κερωμένη Πόρτα Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Κερωμένο Άγαλμα Γκόλεμ Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_grate": "Κερωμένη Σχάρα Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_lantern": "Κερωμένο Φανάρι Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Κερωμένη Καταπακτή Εκτεθειμένου Χαλκού",
  "block.minecraft.waxed_exposed_cut_copper": "Κερωμένος Εκτεθειμένος Κομμένος Χαλκός",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Κερωμένη Πλάκα Εκτεθειμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Κερωμένες Σκάλες Εκτεθειμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_exposed_lightning_rod": "Κερωμένο Εκτεθειμένο Αλεξικέραυνο",
  "block.minecraft.waxed_lightning_rod": "Κερωμένο Αλεξικέραυνο",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Κερωμένος Οξειδωμένος Λαξευμένος Χαλκός",
  "block.minecraft.waxed_oxidized_copper": "Κερωμένος Οξειδωμένος Χαλκός",
  "block.minecraft.waxed_oxidized_copper_bars": "Κερωμένα Κάγκελα Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_bulb": "Κερωμένη Λάμπα Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_chain": "Κερωμένη Αλυσίδα Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_chest": "Κερωμένο Σεντούκι Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_door": "Κερωμένη Πόρτα Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Κερωμένο Άγαλμα Γκόλεμ Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_grate": "Κερωμένη Σχάρα Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_lantern": "Κερωμένο Φανάρι Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Κερωμένη Καταπακτή Οξειδωμένου Χαλκού",
  "block.minecraft.waxed_oxidized_cut_copper": "Κερωμένος Οξειδωμένος Κομμένος Χαλκός",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Κερωμένη Πλάκα Οξειδωμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Κερωμένες Σκάλες Οξειδωμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_oxidized_lightning_rod": "Κερωμένο Οξειδωμένο Αλεξικέραυνο",
  "block.minecraft.waxed_weathered_chiseled_copper": "Κερωμένος Φθαρμένος Λαξευμένος Χαλκός",
  "block.minecraft.waxed_weathered_copper": "Κερωμένος Φθαρμένος Χαλκός",
  "block.minecraft.waxed_weathered_copper_bars": "Κερωμένα Κάγκελα Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_bulb": "Κερωμένη Λάμπα Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_chain": "Κερωμένη Αλυσίδα Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_chest": "Κερωμένο Σεντούκι Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_door": "Κερωμένη Πόρτα Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Κερωμένο Άγαλμα Γκόλεμ Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_grate": "Κερωμένη Σχάρα Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_lantern": "Κερωμένο Φανάρι Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Κερωμένη Καταπακτή Φθαρμένου Χαλκού",
  "block.minecraft.waxed_weathered_cut_copper": "Κερωμένος Φθαρμένος Κομμένος Χαλκός",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Κερωμένη Πλάκα Φθαρμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Κερωμένες Σκάλες Φθαρμένου Κομμένου Χαλκού",
  "block.minecraft.waxed_weathered_lightning_rod": "Κερωμένο Φθαρμένο Αλεξικέραυνο",
  "block.minecraft.weathered_chiseled_copper": "Φθαρμένος Λαξευμένος Χαλκός",
  "block.minecraft.weathered_copper": "Φθαρμένος Χαλκός",
  "block.minecraft.weathered_copper_bars": "Κάγκελα Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_bulb": "Λάμπα Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_chain": "Αλυσίδα Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_chest": "Σεντούκι Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_door": "Πόρτα Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_golem_statue": "Άγαλμα Γκόλεμ Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_grate": "Σχάρα Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_lantern": "Φανάρι Φθαρμένου Χαλκού",
  "block.minecraft.weathered_copper_trapdoor": "Καταπακτή Φθαρμένου Χαλκού",
  "block.minecraft.weathered_cut_copper": "Φθαρμένος Κομμένος Χαλκός",
  "block.minecraft.weathered_cut_copper_slab": "Πλάκα Φθαρμένου Κομμένου Χαλκού",
  "block.minecraft.weathered_cut_copper_stairs": "Σκάλες Φθαρμένου Κομμένου Χαλκού",
  "block.minecraft.weathered_lightning_rod": "Φθαρμένο Αλεξικέραυνο",
  "block.minecraft.weeping_vines": "Κλαίουσες Κληματσίδες",
  "block.minecraft.weeping_vines_plant": "Φυτό Κλαιούσων Κληματσίδων",
  "block.minecraft.wet_sponge": "Βρεγμένο Σφουγγάρι",
  "block.minecraft.wheat": "Καλλιέργεια Σιταριού",
  "block.minecraft.white_banner": "Λευκό Λάβαρο",
  "block.minecraft.white_bed": "Λευκό Κρεβάτι",
  "block.minecraft.white_candle": "Λευκό Κερί",
  "block.minecraft.white_candle_cake": "Τούρτα με Λευκό Κερί",
  "block.minecraft.white_carpet": "Λευκό Χαλί",
  "block.minecraft.white_concrete": "Λευκό Σκυρόδεμα",
  "block.minecraft.white_concrete_powder": "Λευκή Σκόνη Σκυροδέματος",
  "block.minecraft.white_glazed_terracotta": "Λευκή Γυαλισμένη Τερακότα",
  "block.minecraft.white_shulker_box": "Λευκό Κιβώτιο Σάλκερ",
  "block.minecraft.white_stained_glass": "Λευκό Χρωματισμένο Γυαλί",
  "block.minecraft.white_stained_glass_pane": "Λευκός Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.white_terracotta": "Λευκή Τερακότα",
  "block.minecraft.white_tulip": "Λευκή Τουλίπα",
  "block.minecraft.white_wool": "Λευκό Μαλλί",
  "block.minecraft.wildflowers": "Αγριολούλουδα",
  "block.minecraft.wither_rose": "Τριαντάφυλλο Ουίδερ",
  "block.minecraft.wither_skeleton_skull": "Κρανίο Σκελετού Ουίδερ",
  "block.minecraft.wither_skeleton_wall_skull": "Κρανίο Τοίχου Σκελετού Ουίδερ",
  "block.minecraft.yellow_banner": "Κίτρινο Λάβαρο",
  "block.minecraft.yellow_bed": "Κίτρινο Κρεβάτι",
  "block.minecraft.yellow_candle": "Κίτρινο Κερί",
  "block.minecraft.yellow_candle_cake": "Τούρτα με Κίτρινο Κερί",
  "block.minecraft.yellow_carpet": "Κίτρινο Χαλί",
  "block.minecraft.yellow_concrete": "Κίτρινο Σκυρόδεμα",
  "block.minecraft.yellow_concrete_powder": "Κίτρινη Σκόνη Σκυροδέματος",
  "block.minecraft.yellow_glazed_terracotta": "Κίτρινη Γυαλισμένη Τερακότα",
  "block.minecraft.yellow_shulker_box": "Κίτρινο Κιβώτιο Σάλκερ",
  "block.minecraft.yellow_stained_glass": "Κίτρινο Χρωματισμένο Γυαλί",
  "block.minecraft.yellow_stained_glass_pane": "Κίτρινος Χρωματισμένος Υαλοπίνακας",
  "block.minecraft.yellow_terracotta": "Κίτρινη Τερακότα",
  "block.minecraft.yellow_wool": "Κίτρινο Μαλλί",
  "block.minecraft.zombie_head": "Κεφάλι Ζόμπι",
  "block.minecraft.zombie_wall_head": "Κεφάλι Τοίχου Ζόμπι",
  "item.minecraft.acacia_boat": "Βάρκα Ακακίας",
  "item.minecraft.acacia_chest_boat": "Βάρκα Ακακίας με Σεντούκι",
  "item.minecraft.allay_spawn_egg": "Αβγό Γέννησης Κατευναστή",
  "item.minecraft.amethyst_shard": "Θραύσμα Αμέθυστου",
  "item.minecraft.angler_pottery_shard": "Θραύσμα Αγγειοπλαστικής Ψαρά",
  "item.minecraft.angler_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ψαρά",
  "item.minecraft.apple": "Μήλο",
  "item.minecraft.archer_pottery_shard": "Θραύσμα Αγγειοπλαστικής Τοξότη",
  "item.minecraft.archer_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Τοξότη",
  "item.minecraft.armadillo_scute": "Φολίδα Αρμαδίλου",
  "item.minecraft.armadillo_spawn_egg": "Αβγό Γέννησης Αρμαδίλου",
  "item.minecraft.armor_stand": "Πάγκος Πανοπλίας",
  "item.minecraft.arms_up_pottery_shard": "Θραύσμα Αγγειοπλαστικής Ανυψωμένων Χεριών",
  "item.minecraft.arms_up_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ανυψωμένων Χεριών",
  "item.minecraft.arrow": "Βέλος",
  "item.minecraft.axolotl_bucket": "Κουβάς με Αξολότλ",
  "item.minecraft.axolotl_spawn_egg": "Αβγό Γέννησης Αξολότλ",
  "item.minecraft.baked_potato": "Ψημένη Πατάτα",
  "item.minecraft.bamboo_chest_raft": "Σχεδία Μπαμπού με Σεντούκι",
  "item.minecraft.bamboo_raft": "Σχεδία Μπαμπού",
  "item.minecraft.bat_spawn_egg": "Αβγό Γέννησης Νυχτερίδας",
  "item.minecraft.bee_spawn_egg": "Αβγό Γέννησης Μέλισσας",
  "item.minecraft.beef": "Ωμό Βοδινό",
  "item.minecraft.beetroot": "Παντζάρι",
  "item.minecraft.beetroot_seeds": "Σπόροι Παντζαριού",
  "item.minecraft.beetroot_soup": "Σούπα Παντζαριού",
  "item.minecraft.birch_boat": "Βάρκα Σημύδας",
  "item.minecraft.birch_chest_boat": "Βάρκα Σημύδας με Σεντούκι",
  "item.minecraft.black_bundle": "Μαύρο Δέμα",
  "item.minecraft.black_dye": "Μαύρη Βαφή",
  "item.minecraft.black_harness": "Μαύρη Σαγή",
  "item.minecraft.blade_pottery_shard": "Θραύσμα Αγγειοπλαστικής Λεπίδας",
  "item.minecraft.blade_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Λεπίδας",
  "item.minecraft.blaze_powder": "Σκόνη Πυροστρόβιλου",
  "item.minecraft.blaze_rod": "Ράβδος Πυροστρόβιλου",
  "item.minecraft.blaze_spawn_egg": "Αβγό Γέννησης Πυροστρόβιλου",
  "item.minecraft.blue_bundle": "Μπλε Δέμα",
  "item.minecraft.blue_dye": "Μπλε Βαφή",
  "item.minecraft.blue_egg": "Μπλε Αβγό",
  "item.minecraft.blue_harness": "Μπλε Σαγή",
  "item.minecraft.bogged_spawn_egg": "Αβγό Γέννησης Βαλτωμένου",
  "item.minecraft.bolt_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Κοχλία",
  "item.minecraft.bone": "Οστό",
  "item.minecraft.bone_meal": "Οστεάλευρο",
  "item.minecraft.book": "Βιβλίο",
  "item.minecraft.bordure_indented_banner_pattern": "Σχέδιο Λάβαρου Οδοντωτής Περιμετρικής Λωρίδας",
  "item.minecraft.bow": "Τόξο",
  "item.minecraft.bowl": "Μπολ",
  "item.minecraft.bread": "Ψωμί",
  "item.minecraft.breeze_rod": "Ράβδος Ανεμοστρόβιλου",
  "item.minecraft.breeze_spawn_egg": "Αβγό Γέννησης Ανεμοστρόβιλου",
  "item.minecraft.brewer_pottery_shard": "Θραύσμα Αγγειοπλαστικής Παρασκευαστή",
  "item.minecraft.brewer_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Παρασκευαστή",
  "item.minecraft.brewing_stand": "Πάγκος Παρασκευής",
  "item.minecraft.brick": "Τούβλο",
  "item.minecraft.brown_bundle": "Καφέ Δέμα",
  "item.minecraft.brown_dye": "Καφέ Βαφή",
  "item.minecraft.brown_egg": "Καφέ Αβγό",
  "item.minecraft.brown_harness": "Καφέ Σαγή",
  "item.minecraft.brush": "Ξεσκονιστήρι",
  "item.minecraft.bucket": "Κουβάς",
  "item.minecraft.bundle": "Δέμα",
  "item.minecraft.bundle.empty": "Άδειο",
  "item.minecraft.bundle.empty.description": "Μπορεί να κρατήσει έναν μικτό συνδυασμό αντικειμένων",
  "item.minecraft.bundle.full": "Γεμάτο",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Θραύσμα Αγγειοπλαστικής Φωτιάς",
  "item.minecraft.burn_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Φωτιάς",
  "item.minecraft.camel_husk_spawn_egg": "Αβγό Γέννησης Μούμιας Καμήλας",
  "item.minecraft.camel_spawn_egg": "Αβγό Γέννησης Καμήλας",
  "item.minecraft.carrot": "Καρώτο",
  "item.minecraft.carrot_on_a_stick": "Καρώτο σε Ξυλάκι",
  "item.minecraft.cat_spawn_egg": "Αβγό Γέννησης Γάτας",
  "item.minecraft.cauldron": "Καζάνι",
  "item.minecraft.cave_spider_spawn_egg": "Αβγό Γέννησης Αράχνης Σπηλιάς",
  "item.minecraft.chainmail_boots": "Αλυσιδωτές Μπότες",
  "item.minecraft.chainmail_chestplate": "Αλυσιδωτός Θώρακας",
  "item.minecraft.chainmail_helmet": "Αλυσιδωτό Κράνος",
  "item.minecraft.chainmail_leggings": "Αλυσιδωτές Περικνημίδες",
  "item.minecraft.charcoal": "Ξυλοκάρβουνο",
  "item.minecraft.cherry_boat": "Βάρκα Κερασιάς",
  "item.minecraft.cherry_chest_boat": "Βάρκα Κερασιάς με Σεντούκι",
  "item.minecraft.chest_minecart": "Βαγονέτο με Σεντούκι",
  "item.minecraft.chicken": "Ωμό Κοτόπουλο",
  "item.minecraft.chicken_spawn_egg": "Αβγό Γέννησης Κότας",
  "item.minecraft.chorus_fruit": "Χορικό Φρούτο",
  "item.minecraft.clay_ball": "Μπάλα Πηλού",
  "item.minecraft.clock": "Ρολόι",
  "item.minecraft.coal": "Κάρβουνο",
  "item.minecraft.coast_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Ακτής",
  "item.minecraft.cocoa_beans": "Σπόροι Κακάο",
  "item.minecraft.cod": "Ωμός Μπακαλιάρος",
  "item.minecraft.cod_bucket": "Κουβάς με Μπακαλιάρο",
  "item.minecraft.cod_spawn_egg": "Αβγό Γέννησης Μπακαλιάρου",
  "item.minecraft.command_block_minecart": "Βαγονέτο με Κύβο Εντολής",
  "item.minecraft.compass": "Πυξίδα",
  "item.minecraft.cooked_beef": "Μαγειρεμένο Βοδινό",
  "item.minecraft.cooked_chicken": "Μαγειρεμένο Κοτόπουλο",
  "item.minecraft.cooked_cod": "Μαγειρεμένος Μπακαλιάρος",
  "item.minecraft.cooked_mutton": "Μαγειρεμένο Πρόβειο Κρέας",
  "item.minecraft.cooked_porkchop": "Μαγειρεμένο Χοιρινό",
  "item.minecraft.cooked_rabbit": "Μαγειρεμένο Κρέας Κουνελιού",
  "item.minecraft.cooked_salmon": "Μαγειρεμένος Σολομός",
  "item.minecraft.cookie": "Μπισκότο",
  "item.minecraft.copper_axe": "Χάλκινο Τσεκούρι",
  "item.minecraft.copper_boots": "Χάλκινες Μπότες",
  "item.minecraft.copper_chestplate": "Χάλκινος Θώρακας",
  "item.minecraft.copper_golem_spawn_egg": "Αβγό Γέννησης Γκόλεμ Χαλκού",
  "item.minecraft.copper_helmet": "Χάλκινο Κράνος",
  "item.minecraft.copper_hoe": "Χάλκινη Τσάπα",
  "item.minecraft.copper_horse_armor": "Χάλκινη Πανοπλία Αλόγου",
  "item.minecraft.copper_ingot": "Ράβδος Χαλκού",
  "item.minecraft.copper_leggings": "Χάλκινες Περικνημίδες",
  "item.minecraft.copper_nautilus_armor": "Χάλκινη Πανοπλία Ναυτίλου",
  "item.minecraft.copper_nugget": "Σβώλος Χαλκού",
  "item.minecraft.copper_pickaxe": "Χάλκινη Αξίνα",
  "item.minecraft.copper_shovel": "Χάλκινο Φτυάρι",
  "item.minecraft.copper_spear": "Χάλκινο Δόρυ",
  "item.minecraft.copper_sword": "Χάλκινο Σπαθί",
  "item.minecraft.cow_spawn_egg": "Αβγό Γέννησης Αγελάδας",
  "item.minecraft.creaking_spawn_egg": "Αβγό Γέννησης Τριξιτή",
  "item.minecraft.creeper_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.creeper_banner_pattern.desc": "Σήμα Κρίπερ",
  "item.minecraft.creeper_banner_pattern.new": "Σχέδιο Λάβαρου Σήματος Κρίπερ",
  "item.minecraft.creeper_spawn_egg": "Αβγό Γέννησης Κρίπερ",
  "item.minecraft.crossbow": "Βαλλίστρα",
  "item.minecraft.crossbow.projectile": "Βλήμα:",
  "item.minecraft.crossbow.projectile.multiple": "Βλήμα: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Βλήμα: %s",
  "item.minecraft.cyan_bundle": "Κυανό Δέμα",
  "item.minecraft.cyan_dye": "Κυανή Βαφή",
  "item.minecraft.cyan_harness": "Κυανή Σαγή",
  "item.minecraft.danger_pottery_shard": "Θραύσμα Αγγειοπλαστικής Κινδύνου",
  "item.minecraft.danger_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Κινδύνου",
  "item.minecraft.dark_oak_boat": "Βάρκα Σκούρας Βελανιδιάς",
  "item.minecraft.dark_oak_chest_boat": "Βάρκα Σκούρας Βελανιδιάς με Σεντούκι",
  "item.minecraft.debug_stick": "Ραβδί Αποσφαλμάτωσης",
  "item.minecraft.debug_stick.empty": "Ο κύβος %s δεν έχει ιδιότητες",
  "item.minecraft.debug_stick.select": "επιλογή «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» σε %s",
  "item.minecraft.diamond": "Διαμάντι",
  "item.minecraft.diamond_axe": "Διαμαντένιο Τσεκούρι",
  "item.minecraft.diamond_boots": "Διαμαντένιες Μπότες",
  "item.minecraft.diamond_chestplate": "Διαμαντένιος Θώρακας",
  "item.minecraft.diamond_helmet": "Διαμαντένιο Κράνος",
  "item.minecraft.diamond_hoe": "Διαμαντένια Τσάπα",
  "item.minecraft.diamond_horse_armor": "Διαμαντένια Πανοπλία Αλόγου",
  "item.minecraft.diamond_leggings": "Διαμαντένιες Περικνημίδες",
  "item.minecraft.diamond_nautilus_armor": "Διαμαντένια Πανοπλία Ναυτίλου",
  "item.minecraft.diamond_pickaxe": "Διαμαντένια Αξίνα",
  "item.minecraft.diamond_shovel": "Διαμαντένιο Φτυάρι",
  "item.minecraft.diamond_spear": "Διαμαντένιο Δόρυ",
  "item.minecraft.diamond_sword": "Διαμαντένιο Σπαθί",
  "item.minecraft.disc_fragment_5": "Θραύσμα Δίσκου",
  "item.minecraft.disc_fragment_5.desc": "Μουσικός Δίσκος - 5",
  "item.minecraft.dolphin_spawn_egg": "Αβγό Γέννησης Δελφινιού",
  "item.minecraft.donkey_spawn_egg": "Αβγό Γέννησης Γαϊδάρου",
  "item.minecraft.dragon_breath": "Αναπνοή Δράκου",
  "item.minecraft.dried_kelp": "Αποξηραμένο Φύκι",
  "item.minecraft.drowned_spawn_egg": "Αβγό Γέννησης Πνιγμένου",
  "item.minecraft.dune_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Αμμόλοφου",
  "item.minecraft.echo_shard": "Θραύσμα Ηχούς",
  "item.minecraft.egg": "Αβγό",
  "item.minecraft.elder_guardian_spawn_egg": "Αβγό Γέννησης Πρεσβύτερου Προστάτη",
  "item.minecraft.elytra": "Έλυτρα",
  "item.minecraft.emerald": "Σμαράγδι",
  "item.minecraft.enchanted_book": "Μαγεμένο Βιβλίο",
  "item.minecraft.enchanted_golden_apple": "Μαγεμένο Χρυσό Μήλο",
  "item.minecraft.end_crystal": "Κρύσταλλος Εντ",
  "item.minecraft.ender_dragon_spawn_egg": "Αβγό Γέννησης Δράκου Έντερ",
  "item.minecraft.ender_eye": "Μάτι του Έντερ",
  "item.minecraft.ender_pearl": "Μαργαριτάρι Έντερ",
  "item.minecraft.enderman_spawn_egg": "Αβγό Γέννησης Έντερμαν",
  "item.minecraft.endermite_spawn_egg": "Αβγό Γέννησης Εντερμίτη",
  "item.minecraft.evoker_spawn_egg": "Αβγό Γέννησης Επικαλεστή",
  "item.minecraft.experience_bottle": "Μπουκάλι Μαγέματος",
  "item.minecraft.explorer_pottery_shard": "Θραύσμα Αγγειοπλαστικής Εξερευνητή",
  "item.minecraft.explorer_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Εξερευνητή",
  "item.minecraft.eye_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Ματιού",
  "item.minecraft.feather": "Φτερό",
  "item.minecraft.fermented_spider_eye": "Ζυμωμένο Μάτι Αράχνης",
  "item.minecraft.field_masoned_banner_pattern": "Σχέδιο Λάβαρου Φόντου Τούβλων",
  "item.minecraft.filled_map": "Χάρτης",
  "item.minecraft.fire_charge": "Φορτίο Φωτιάς",
  "item.minecraft.firework_rocket": "Φωτοβολίδα Πυροτεχνήματος",
  "item.minecraft.firework_rocket.flight": "Διάρκεια Πτήσης:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Πυροκροτητής Πυροτεχνήματος",
  "item.minecraft.firework_star.black": "Μαύρο",
  "item.minecraft.firework_star.blue": "Μπλε",
  "item.minecraft.firework_star.brown": "Καφέ",
  "item.minecraft.firework_star.custom_color": "Προσαρμοσμένο",
  "item.minecraft.firework_star.cyan": "Κυανό",
  "item.minecraft.firework_star.fade_to": "Εξασθενεί σε",
  "item.minecraft.firework_star.flicker": "Σπινθήρισμα",
  "item.minecraft.firework_star.gray": "Γκρίζο",
  "item.minecraft.firework_star.green": "Πράσινο",
  "item.minecraft.firework_star.light_blue": "Γαλάζιο",
  "item.minecraft.firework_star.light_gray": "Ανοιχτό Γκρίζο",
  "item.minecraft.firework_star.lime": "Λαχανί",
  "item.minecraft.firework_star.magenta": "Φούξια",
  "item.minecraft.firework_star.orange": "Πορτοκαλί",
  "item.minecraft.firework_star.pink": "Ροζ",
  "item.minecraft.firework_star.purple": "Μοβ",
  "item.minecraft.firework_star.red": "Κόκκινο",
  "item.minecraft.firework_star.shape": "Άγνωστο Σχήμα",
  "item.minecraft.firework_star.shape.burst": "Έκρηξη",
  "item.minecraft.firework_star.shape.creeper": "Σχήμα Κρίπερ",
  "item.minecraft.firework_star.shape.large_ball": "Μεγάλη Μπάλα",
  "item.minecraft.firework_star.shape.small_ball": "Μικρή Μπάλα",
  "item.minecraft.firework_star.shape.star": "Σχήμα αστεριού",
  "item.minecraft.firework_star.trail": "Ίχνος",
  "item.minecraft.firework_star.white": "Λευκό",
  "item.minecraft.firework_star.yellow": "Κίτρινο",
  "item.minecraft.fishing_rod": "Καλάμι Ψαρέματος",
  "item.minecraft.flint": "Πυρόλιθος",
  "item.minecraft.flint_and_steel": "Πυρόλιθος και Χάλυβας",
  "item.minecraft.flow_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Ροής",
  "item.minecraft.flow_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.flow_banner_pattern.desc": "Ροή",
  "item.minecraft.flow_banner_pattern.new": "Σχέδιο Λάβαρου Ροής",
  "item.minecraft.flow_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ροής",
  "item.minecraft.flower_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.flower_banner_pattern.desc": "Σήμα Άνθους",
  "item.minecraft.flower_banner_pattern.new": "Σχέδιο Λάβαρου Σήματος Άνθους",
  "item.minecraft.flower_pot": "Γλάστρα",
  "item.minecraft.fox_spawn_egg": "Αβγό Γέννησης Αλεπούς",
  "item.minecraft.friend_pottery_shard": "Θραύσμα Αγγειοπλαστικής Φίλου",
  "item.minecraft.friend_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Φίλου",
  "item.minecraft.frog_spawn_egg": "Αβγό Γέννησης Βατράχου",
  "item.minecraft.furnace_minecart": "Βαγονέτο με Φούρνο",
  "item.minecraft.ghast_spawn_egg": "Αβγό Γέννησης Γκαστ",
  "item.minecraft.ghast_tear": "Δάκρυ Γκαστ",
  "item.minecraft.glass_bottle": "Γυάλινο Μπουκάλι",
  "item.minecraft.glistering_melon_slice": "Αστραφτερή Φέτα Καρπουζιού",
  "item.minecraft.globe_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.globe_banner_pattern.desc": "Υδρόγειος",
  "item.minecraft.globe_banner_pattern.new": "Σχέδιο Λάβαρου Υδρογείου",
  "item.minecraft.glow_berries": "Λαμπερά Μούρα",
  "item.minecraft.glow_ink_sac": "Λαμπερός Θύλακας Μελανιού",
  "item.minecraft.glow_item_frame": "Λαμπερή Κορνίζα Αντικειμένου",
  "item.minecraft.glow_squid_spawn_egg": "Αβγό Γέννησης Λαμπερού Καλαμαριού",
  "item.minecraft.glowstone_dust": "Σκόνη Λαμψόπετρας",
  "item.minecraft.goat_horn": "Κέρατο Κατσίκας",
  "item.minecraft.goat_spawn_egg": "Αβγό Γέννησης Κατσίκας",
  "item.minecraft.gold_ingot": "Ράβδος Χρυσού",
  "item.minecraft.gold_nugget": "Σβώλος Χρυσού",
  "item.minecraft.golden_apple": "Χρυσό Μήλο",
  "item.minecraft.golden_axe": "Χρυσό Τσεκούρι",
  "item.minecraft.golden_boots": "Χρυσές Μπότες",
  "item.minecraft.golden_carrot": "Χρυσό Καρώτο",
  "item.minecraft.golden_chestplate": "Χρυσός Θώρακας",
  "item.minecraft.golden_helmet": "Χρυσό Κράνος",
  "item.minecraft.golden_hoe": "Χρυσή Τσάπα",
  "item.minecraft.golden_horse_armor": "Χρυσή Πανοπλία Αλόγου",
  "item.minecraft.golden_leggings": "Χρυσές Περικνημίδες",
  "item.minecraft.golden_nautilus_armor": "Χρυσή Πανοπλία Ναυτίλου",
  "item.minecraft.golden_pickaxe": "Χρυσή Αξίνα",
  "item.minecraft.golden_shovel": "Χρυσό Φτυάρι",
  "item.minecraft.golden_spear": "Χρυσό Δόρυ",
  "item.minecraft.golden_sword": "Χρυσό Σπαθί",
  "item.minecraft.gray_bundle": "Γκρίζο Δέμα",
  "item.minecraft.gray_dye": "Γκρίζα Βαφή",
  "item.minecraft.gray_harness": "Γκρίζα Σαγή",
  "item.minecraft.green_bundle": "Πράσινο Δέμα",
  "item.minecraft.green_dye": "Πράσινη Βαφή",
  "item.minecraft.green_harness": "Πράσινη Σαγή",
  "item.minecraft.guardian_spawn_egg": "Αβγό Γέννησης Προστάτη",
  "item.minecraft.gunpowder": "Πυρίτιδα",
  "item.minecraft.guster_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.guster_banner_pattern.desc": "Ριπή",
  "item.minecraft.guster_banner_pattern.new": "Σχέδιο Λάβαρου Ριπής",
  "item.minecraft.guster_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ριπής",
  "item.minecraft.happy_ghast_spawn_egg": "Αβγό Γέννησης Ευτυχισμένου Γκαστ",
  "item.minecraft.harness": "Σαγή",
  "item.minecraft.heart_of_the_sea": "Καρδιά της Θάλασσας",
  "item.minecraft.heart_pottery_shard": "Θραύσμα Αγγειοπλαστικής Καρδιάς",
  "item.minecraft.heart_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Καρδιάς",
  "item.minecraft.heartbreak_pottery_shard": "Θραύσμα Αγγειοπλαστικής Σπαραγμού",
  "item.minecraft.heartbreak_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Σπαραγμού",
  "item.minecraft.hoglin_spawn_egg": "Αβγό Γέννησης Χόγκλιν",
  "item.minecraft.honey_bottle": "Μπουκάλι Μελιού",
  "item.minecraft.honeycomb": "Κηρήθρα",
  "item.minecraft.hopper_minecart": "Βαγονέτο με Χοάνη",
  "item.minecraft.horse_spawn_egg": "Αβγό Γέννησης Αλόγου",
  "item.minecraft.host_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.host_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Οικοδεσπότη",
  "item.minecraft.howl_pottery_shard": "Θραύσμα Αγγειοπλαστικής Ουρλιαχτού",
  "item.minecraft.howl_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ουρλιαχτού",
  "item.minecraft.husk_spawn_egg": "Αβγό Γέννησης Μούμιας",
  "item.minecraft.ink_sac": "Θύλακας Μελανιού",
  "item.minecraft.iron_axe": "Σιδερένιο Τσεκούρι",
  "item.minecraft.iron_boots": "Σιδερένιες Μπότες",
  "item.minecraft.iron_chestplate": "Σιδερένιος Θώρακας",
  "item.minecraft.iron_golem_spawn_egg": "Αβγό Γέννησης Γκόλεμ Σιδήρου",
  "item.minecraft.iron_helmet": "Σιδερένιο Κράνος",
  "item.minecraft.iron_hoe": "Σιδερένια Τσάπα",
  "item.minecraft.iron_horse_armor": "Σιδερένια Πανοπλία Αλόγου",
  "item.minecraft.iron_ingot": "Ράβδος Σιδήρου",
  "item.minecraft.iron_leggings": "Σιδερένιες Περικνημίδες",
  "item.minecraft.iron_nautilus_armor": "Σιδερένια Πανοπλία Ναυτίλου",
  "item.minecraft.iron_nugget": "Σβώλος Σιδήρου",
  "item.minecraft.iron_pickaxe": "Σιδερένια Αξίνα",
  "item.minecraft.iron_shovel": "Σιδερένιο Φτυάρι",
  "item.minecraft.iron_spear": "Σιδερένιο Δόρυ",
  "item.minecraft.iron_sword": "Σιδερένιο Σπαθί",
  "item.minecraft.item_frame": "Κορνίζα Αντικειμένου",
  "item.minecraft.jungle_boat": "Βάρκα Ζούγκλας",
  "item.minecraft.jungle_chest_boat": "Βάρκα Ζούγκλας με Σεντούκι",
  "item.minecraft.knowledge_book": "Βιβλίο Γνώσεων",
  "item.minecraft.lapis_lazuli": "Λάπις Λάζουλι",
  "item.minecraft.lava_bucket": "Κουβάς Λάβας",
  "item.minecraft.lead": "Λουρί",
  "item.minecraft.leather": "Δέρμα",
  "item.minecraft.leather_boots": "Δερμάτινες Μπότες",
  "item.minecraft.leather_chestplate": "Δερμάτινο Χιτώνιο",
  "item.minecraft.leather_helmet": "Δερμάτινο Σκουφί",
  "item.minecraft.leather_horse_armor": "Δερμάτινη Πανοπλία Αλόγου",
  "item.minecraft.leather_leggings": "Δερμάτινο Παντελόνι",
  "item.minecraft.light_blue_bundle": "Γαλάζιο Δέμα",
  "item.minecraft.light_blue_dye": "Γαλάζια Βαφή",
  "item.minecraft.light_blue_harness": "Ανοιχτή Μπλε Σαγή",
  "item.minecraft.light_gray_bundle": "Ανοιχτό Γκρίζο Δέμα",
  "item.minecraft.light_gray_dye": "Ανοιχτή Γκρίζα Βαφή",
  "item.minecraft.light_gray_harness": "Ανοιχτή Γκρίζα Σαγή",
  "item.minecraft.lime_bundle": "Λαχανί Δέμα",
  "item.minecraft.lime_dye": "Λαχανί Βαφή",
  "item.minecraft.lime_harness": "Λαχανί Σαγή",
  "item.minecraft.lingering_potion": "Φίλτρο Διαρκείας",
  "item.minecraft.lingering_potion.effect.awkward": "Παράξενο Φίλτρο Διαρκείας",
  "item.minecraft.lingering_potion.effect.empty": "Μη Κατασκευάσιμο Φίλτρο Διαρκείας",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Φίλτρο Διαρκείας Αντίστασης Φωτιάς",
  "item.minecraft.lingering_potion.effect.harming": "Φίλτρο Διαρκείας Βλάβης",
  "item.minecraft.lingering_potion.effect.healing": "Φίλτρο Διαρκείας Θεραπείας",
  "item.minecraft.lingering_potion.effect.infested": "Φίλτρο Διαρκείας Μόλυνσης",
  "item.minecraft.lingering_potion.effect.invisibility": "Φίλτρο Διαρκείας Αορατότητας",
  "item.minecraft.lingering_potion.effect.leaping": "Φίλτρο Διαρκείας Άλματος",
  "item.minecraft.lingering_potion.effect.levitation": "Φίλτρο Διαρκείας Ανύψωσης",
  "item.minecraft.lingering_potion.effect.luck": "Φίλτρο Διαρκείας Τύχης",
  "item.minecraft.lingering_potion.effect.mundane": "Κοινό Φίλτρο Διαρκείας",
  "item.minecraft.lingering_potion.effect.night_vision": "Φίλτρο Διαρκείας Νυχτερινής Όρασης",
  "item.minecraft.lingering_potion.effect.oozing": "Φίλτρο Διαρκείας Γλιτσοροής",
  "item.minecraft.lingering_potion.effect.poison": "Φίλτρο Διαρκείας Δηλητηρίου",
  "item.minecraft.lingering_potion.effect.regeneration": "Φίλτρο Διαρκείας Αναζωογόνησης",
  "item.minecraft.lingering_potion.effect.slow_falling": "Φίλτρο Διαρκείας Αργής Πτώσης",
  "item.minecraft.lingering_potion.effect.slowness": "Φίλτρο Διαρκείας Βραδύτητας",
  "item.minecraft.lingering_potion.effect.strength": "Φίλτρο Διαρκείας Ισχύος",
  "item.minecraft.lingering_potion.effect.swiftness": "Φίλτρο Διαρκείας Ταχύτητας",
  "item.minecraft.lingering_potion.effect.thick": "Πηχτό Φίλτρο Διαρκείας",
  "item.minecraft.lingering_potion.effect.turtle_master": "Φίλτρο Διαρκείας του Αφέντη των Χελώνων",
  "item.minecraft.lingering_potion.effect.water": "Μπουκάλι Διαρκείας Νερού",
  "item.minecraft.lingering_potion.effect.water_breathing": "Φίλτρο Διαρκείας Υποβρύχιας Αναπνοής",
  "item.minecraft.lingering_potion.effect.weakness": "Φίλτρο Διαρκείας Αδυναμίας",
  "item.minecraft.lingering_potion.effect.weaving": "Φίλτρο Διαρκείας Πλεξίματος",
  "item.minecraft.lingering_potion.effect.wind_charged": "Φίλτρο Διαρκείας Ανεμοφορίας",
  "item.minecraft.llama_spawn_egg": "Αβγό Γέννησης Λάμα",
  "item.minecraft.lodestone_compass": "Μαγνητισμένη Πυξίδα",
  "item.minecraft.mace": "Απελατίκι",
  "item.minecraft.magenta_bundle": "Φούξια Δέμα",
  "item.minecraft.magenta_dye": "Φούξια Βαφή",
  "item.minecraft.magenta_harness": "Φούξια Σαγή",
  "item.minecraft.magma_cream": "Κρέμα Μάγματος",
  "item.minecraft.magma_cube_spawn_egg": "Αβγό Γέννησης Γλίτσας Μάγματος",
  "item.minecraft.mangrove_boat": "Βάρκα Μαγκροβίου",
  "item.minecraft.mangrove_chest_boat": "Βάρκα Μαγκροβίου με Σεντούκι",
  "item.minecraft.map": "Κενός Χάρτης",
  "item.minecraft.melon_seeds": "Σπόροι Καρπουζιού",
  "item.minecraft.melon_slice": "Φέτα Καρπουζιού",
  "item.minecraft.milk_bucket": "Κουβάς Γάλακτος",
  "item.minecraft.minecart": "Βαγονέτο",
  "item.minecraft.miner_pottery_shard": "Θραύσμα Αγγειοπλαστικής Μεταλλωρύχου",
  "item.minecraft.miner_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Μεταλλωρύχου",
  "item.minecraft.mojang_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.mojang_banner_pattern.desc": "Πράγμα",
  "item.minecraft.mojang_banner_pattern.new": "Σχέδιο Λάβαρου Πράγματος",
  "item.minecraft.mooshroom_spawn_egg": "Αβγό Γέννησης Μούσρουμ",
  "item.minecraft.mourner_pottery_shard": "Θραύσμα Αγγειοπλαστικής Πενθόντος",
  "item.minecraft.mourner_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Πενθόντος",
  "item.minecraft.mule_spawn_egg": "Αβγό Γέννησης Μουλαριού",
  "item.minecraft.mushroom_stew": "Μανιτάρια Στιφάδο",
  "item.minecraft.music_disc_11": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_5.desc": "Σάμουελ Όμπεργκ - 5",
  "item.minecraft.music_disc_blocks": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_creator.desc": "Λένα Ρέιν - Creator",
  "item.minecraft.music_disc_creator_music_box": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_creator_music_box.desc": "Λένα Ρέιν - Creator (Μουσικό Κουτί)",
  "item.minecraft.music_disc_far": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_otherside.desc": "Λένα Ρέιν - otherside",
  "item.minecraft.music_disc_pigstep": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_pigstep.desc": "Λένα Ρέιν - Pigstep",
  "item.minecraft.music_disc_precipice": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_precipice.desc": "Άαρον Σέροφ - Precipice",
  "item.minecraft.music_disc_relic": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_relic.desc": "Άαρον Σέροφ - Relic",
  "item.minecraft.music_disc_stal": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_tears.desc": "Έιμος Ρόντι - Tears",
  "item.minecraft.music_disc_wait": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Μουσικός Δίσκος",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Ωμό Πρόβειο Κρέας",
  "item.minecraft.name_tag": "Ετικέτα Ονόματος",
  "item.minecraft.nautilus_shell": "Κέλυφος Ναυτίλου",
  "item.minecraft.nautilus_spawn_egg": "Αβγό Γέννησης Ναυτίλου",
  "item.minecraft.nether_brick": "Τούβλο Νέδερ",
  "item.minecraft.nether_star": "Αστέρι Νέδερ",
  "item.minecraft.nether_wart": "Στίγμα Νέδερ",
  "item.minecraft.netherite_axe": "Τσεκούρι Νεδερίτη",
  "item.minecraft.netherite_boots": "Μπότες Νεδερίτη",
  "item.minecraft.netherite_chestplate": "Θώρακας Νεδερίτη",
  "item.minecraft.netherite_helmet": "Κράνος Νεδερίτη",
  "item.minecraft.netherite_hoe": "Τσάπα Νεδερίτη",
  "item.minecraft.netherite_horse_armor": "Πανοπλία Αλόγου Νεδερίτη",
  "item.minecraft.netherite_ingot": "Ράβδος Νεδερίτη",
  "item.minecraft.netherite_leggings": "Περικνημίδες Νεδερίτη",
  "item.minecraft.netherite_nautilus_armor": "Πανοπλία Ναυτίλου Νεδερίτη",
  "item.minecraft.netherite_pickaxe": "Αξίνα Νεδερίτη",
  "item.minecraft.netherite_scrap": "Κομμάτι Νεδερίτη",
  "item.minecraft.netherite_shovel": "Φτυάρι Νεδερίτη",
  "item.minecraft.netherite_spear": "Δόρυ Νεδερίτη",
  "item.minecraft.netherite_sword": "Σπαθί Νεδερίτη",
  "item.minecraft.netherite_upgrade_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Αναβάθμιση Νεδερίτη",
  "item.minecraft.oak_boat": "Βάρκα Βελανιδιάς",
  "item.minecraft.oak_chest_boat": "Βάρκα Βελανιδιάς με Σεντούκι",
  "item.minecraft.ocelot_spawn_egg": "Αβγό Γέννησης Οσελότου",
  "item.minecraft.ominous_bottle": "Δυσοίωνο Μπουκάλι",
  "item.minecraft.ominous_trial_key": "Κλειδί Δυσοίωνης Δοκιμασίας",
  "item.minecraft.orange_bundle": "Πορτοκαλί Δέμα",
  "item.minecraft.orange_dye": "Πορτοκαλί Βαφή",
  "item.minecraft.orange_harness": "Πορτοκαλί Σαγή",
  "item.minecraft.painting": "Πίνακας",
  "item.minecraft.pale_oak_boat": "Βάρκα Λευκής Βελανιδιάς",
  "item.minecraft.pale_oak_chest_boat": "Βάρκα Λευκής Βελανιδιάς με Σεντούκι",
  "item.minecraft.panda_spawn_egg": "Αβγό Γέννησης Πάντα",
  "item.minecraft.paper": "Χαρτί",
  "item.minecraft.parched_spawn_egg": "Αβγό Γέννησης Αφυδατωμένου",
  "item.minecraft.parrot_spawn_egg": "Αβγό Γέννησης Παπαγάλου",
  "item.minecraft.phantom_membrane": "Μεμβράνη Φαντάσματος",
  "item.minecraft.phantom_spawn_egg": "Αβγό Γέννησης Φαντάσματος",
  "item.minecraft.pig_spawn_egg": "Αβγό Γέννησης Γουρουνιού",
  "item.minecraft.piglin_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.piglin_banner_pattern.desc": "Μουσούδα",
  "item.minecraft.piglin_banner_pattern.new": "Σχέδιο Λάβαρου Μουσούδας",
  "item.minecraft.piglin_brute_spawn_egg": "Αβγό Γέννησης Κτήνους Πίγκλιν",
  "item.minecraft.piglin_spawn_egg": "Αβγό Γέννησης Πίγκλιν",
  "item.minecraft.pillager_spawn_egg": "Αβγό Γέννησης Λεηλάτη",
  "item.minecraft.pink_bundle": "Ροζ Δέμα",
  "item.minecraft.pink_dye": "Ροζ Βαφή",
  "item.minecraft.pink_harness": "Ροζ Σαγή",
  "item.minecraft.pitcher_plant": "Φυτό Νηπενθούς",
  "item.minecraft.pitcher_pod": "Λοβός Νεπενθούς",
  "item.minecraft.plenty_pottery_shard": "Θραύσμα Αγγειοπλαστικής Αφθονίας",
  "item.minecraft.plenty_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Αφθονίας",
  "item.minecraft.poisonous_potato": "Δηλητηριώδης Πατάτα",
  "item.minecraft.polar_bear_spawn_egg": "Αβγό Γέννησης Πολικής Αρκούδας",
  "item.minecraft.popped_chorus_fruit": "Σκασμένο Χορικό Φρούτο",
  "item.minecraft.porkchop": "Ωμό Χοιρινό",
  "item.minecraft.potato": "Πατάτα",
  "item.minecraft.potion": "Φίλτρο",
  "item.minecraft.potion.effect.awkward": "Παράξενο Φίλτρο",
  "item.minecraft.potion.effect.empty": "Μη Κατασκευάσιμο Φίλτρο",
  "item.minecraft.potion.effect.fire_resistance": "Φίλτρο Αντίστασης Φωτιάς",
  "item.minecraft.potion.effect.harming": "Φίλτρο Βλάβης",
  "item.minecraft.potion.effect.healing": "Φίλτρο Θεραπείας",
  "item.minecraft.potion.effect.infested": "Φίλτρο Μόλυνσης",
  "item.minecraft.potion.effect.invisibility": "Φίλτρο Αορατότητας",
  "item.minecraft.potion.effect.leaping": "Φίλτρο Άλματος",
  "item.minecraft.potion.effect.levitation": "Φίλτρο Ανύψωσης",
  "item.minecraft.potion.effect.luck": "Φίλτρο Τύχης",
  "item.minecraft.potion.effect.mundane": "Κοινό Φίλτρο",
  "item.minecraft.potion.effect.night_vision": "Φίλτρο Νυχτερινής Όρασης",
  "item.minecraft.potion.effect.oozing": "Φίλτρο Γλιτσοροής",
  "item.minecraft.potion.effect.poison": "Φίλτρο Δηλητηρίου",
  "item.minecraft.potion.effect.regeneration": "Φίλτρο Αναζωογόνησης",
  "item.minecraft.potion.effect.slow_falling": "Φίλτρο Αργής Πτώσης",
  "item.minecraft.potion.effect.slowness": "Φίλτρο Βραδύτητας",
  "item.minecraft.potion.effect.strength": "Φίλτρο Ισχύος",
  "item.minecraft.potion.effect.swiftness": "Φίλτρο Ταχύτητας",
  "item.minecraft.potion.effect.thick": "Πηχτό Φίλτρο",
  "item.minecraft.potion.effect.turtle_master": "Φίλτρο του Αφέντη των Χελώνων",
  "item.minecraft.potion.effect.water": "Μπουκάλι Νερού",
  "item.minecraft.potion.effect.water_breathing": "Φίλτρο Υποβρύχιας Αναπνοής",
  "item.minecraft.potion.effect.weakness": "Φίλτρο Αδυναμίας",
  "item.minecraft.potion.effect.weaving": "Φίλτρο Πλεξίματος",
  "item.minecraft.potion.effect.wind_charged": "Φίλτρο Ανεμοφορίας",
  "item.minecraft.pottery_shard_archer": "Θραύσμα Αγγειοπλαστικής Τοξότη",
  "item.minecraft.pottery_shard_arms_up": "Θραύσμα Αγγειοπλαστικής Ανυψωμένων Χεριών",
  "item.minecraft.pottery_shard_prize": "Θραύσμα Αγγειοπλαστικής Βραβείου",
  "item.minecraft.pottery_shard_skull": "Θραύσμα Αγγειοπλαστικής Κρανίου",
  "item.minecraft.powder_snow_bucket": "Κουβάς Φρέσκου Χιονιού",
  "item.minecraft.prismarine_crystals": "Κρύσταλλοι Πρισμαρίνης",
  "item.minecraft.prismarine_shard": "Θραύσμα Πρισμαρίνης",
  "item.minecraft.prize_pottery_shard": "Θραύσμα Αγγειοπλαστικής Βραβείου",
  "item.minecraft.prize_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Βραβείου",
  "item.minecraft.pufferfish": "Ψάρι Φούσκα",
  "item.minecraft.pufferfish_bucket": "Κουβάς με Ψάρι Φούσκα",
  "item.minecraft.pufferfish_spawn_egg": "Αβγό Γέννησης Ψαριού Φούσκας",
  "item.minecraft.pumpkin_pie": "Κολοκυθόπιτα",
  "item.minecraft.pumpkin_seeds": "Σπόροι Κολοκύθας",
  "item.minecraft.purple_bundle": "Μοβ Δέμα",
  "item.minecraft.purple_dye": "Μοβ Βαφή",
  "item.minecraft.purple_harness": "Μοβ Σαγή",
  "item.minecraft.quartz": "Χαλαζίας Νέδερ",
  "item.minecraft.rabbit": "Ωμό Κρέας Κουνελιού",
  "item.minecraft.rabbit_foot": "Λαγοπόδαρο",
  "item.minecraft.rabbit_hide": "Δέρμα Κουνελιού",
  "item.minecraft.rabbit_spawn_egg": "Αβγό Γέννησης Κουνελιού",
  "item.minecraft.rabbit_stew": "Κουνέλι Στιφάδο",
  "item.minecraft.raiser_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Εκτροφέα",
  "item.minecraft.ravager_spawn_egg": "Αβγό Γέννησης Αφανιστή",
  "item.minecraft.raw_copper": "Ακατέργαστος Χαλκός",
  "item.minecraft.raw_gold": "Ακατέργαστος Χρυσός",
  "item.minecraft.raw_iron": "Ακατέργαστος Σίδηρος",
  "item.minecraft.recovery_compass": "Πυξίδα Ανάκτησης",
  "item.minecraft.red_bundle": "Κόκκινο Δέμα",
  "item.minecraft.red_dye": "Κόκκινη Βαφή",
  "item.minecraft.red_harness": "Κόκκινη Σαγή",
  "item.minecraft.redstone": "Σκόνη Ρέντστοουν",
  "item.minecraft.resin_brick": "Τούβλο Ρητίνης",
  "item.minecraft.resin_clump": "Συστάδα Ρητίνης",
  "item.minecraft.rib_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Σκελετού",
  "item.minecraft.rotten_flesh": "Σάπια Σάρκα",
  "item.minecraft.saddle": "Σέλα",
  "item.minecraft.salmon": "Ωμός Σολομός",
  "item.minecraft.salmon_bucket": "Κουβάς με Σολομό",
  "item.minecraft.salmon_spawn_egg": "Αβγό Γέννησης Σολομού",
  "item.minecraft.scrape_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Ξυσίματος",
  "item.minecraft.scute": "Φολίδα",
  "item.minecraft.sentry_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Φρουρού",
  "item.minecraft.shaper_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Διαμορφωτή",
  "item.minecraft.sheaf_pottery_shard": "Θραύσμα Αγγειοπλαστικής Δεματιού",
  "item.minecraft.sheaf_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Δεματιού",
  "item.minecraft.shears": "Ψαλίδα",
  "item.minecraft.sheep_spawn_egg": "Αβγό Γέννησης Προβάτου",
  "item.minecraft.shelter_pottery_shard": "Θραύσμα Αγγειοπλαστικής Καταφυγίου",
  "item.minecraft.shelter_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Καταφυγίου",
  "item.minecraft.shield": "Ασπίδα",
  "item.minecraft.shield.black": "Μαύρη Ασπίδα",
  "item.minecraft.shield.blue": "Μπλε Ασπίδα",
  "item.minecraft.shield.brown": "Καφέ Ασπίδα",
  "item.minecraft.shield.cyan": "Κυανή Ασπίδα",
  "item.minecraft.shield.gray": "Γκρίζα Ασπίδα",
  "item.minecraft.shield.green": "Πράσινη Ασπίδα",
  "item.minecraft.shield.light_blue": "Γαλάζια Ασπίδα",
  "item.minecraft.shield.light_gray": "Ανοιχτή Γκρίζα Ασπίδα",
  "item.minecraft.shield.lime": "Λαχανί Ασπίδα",
  "item.minecraft.shield.magenta": "Φούξια Ασπίδα",
  "item.minecraft.shield.orange": "Πορτοκαλί Ασπίδα",
  "item.minecraft.shield.pink": "Ροζ Ασπίδα",
  "item.minecraft.shield.purple": "Μοβ Ασπίδα",
  "item.minecraft.shield.red": "Κόκκινη Ασπίδα",
  "item.minecraft.shield.white": "Λευκή Ασπίδα",
  "item.minecraft.shield.yellow": "Κίτρινη Ασπίδα",
  "item.minecraft.shulker_shell": "Κέλυφος Σάλκερ",
  "item.minecraft.shulker_spawn_egg": "Αβγό Γέννησης Σάλκερ",
  "item.minecraft.sign": "Πινακίδα",
  "item.minecraft.silence_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Ησυχίας",
  "item.minecraft.silverfish_spawn_egg": "Αβγό Γέννησης Ασημόψαρου",
  "item.minecraft.skeleton_horse_spawn_egg": "Αβγό Γέννησης Αλόγου Σκελετού",
  "item.minecraft.skeleton_spawn_egg": "Αβγό Γέννησης Σκελετού",
  "item.minecraft.skull_banner_pattern": "Σχέδιο Λάβαρου",
  "item.minecraft.skull_banner_pattern.desc": "Σήμα Κρανίου",
  "item.minecraft.skull_banner_pattern.new": "Σχέδιο Λάβαρου Σήματος Κρανίου",
  "item.minecraft.skull_pottery_shard": "Θραύσμα Αγγειοπλαστικής Κρανίου",
  "item.minecraft.skull_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Κρανίου",
  "item.minecraft.slime_ball": "Μπάλα Γλίτσας",
  "item.minecraft.slime_spawn_egg": "Αβγό Γέννησης Γλίτσας",
  "item.minecraft.smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.smithing_template.applies_to": "Ισχύει για:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Πρόσθεσε ράβδο ή κρύσταλλο",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Πανοπλία",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Πρόσθεσε κομμάτι πανοπλίας",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ράβδοι & Κρύσταλλοι",
  "item.minecraft.smithing_template.ingredients": "Συστατικά:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Πρόσθεσε Ράβδο Νεδερίτη",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Διαμαντένιος Εξοπλισμός",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Πρόσθεσε διαμαντένια πανοπλία, όπλο, ή εργαλείο",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Ράβδος Νεδερίτη",
  "item.minecraft.smithing_template.upgrade": "Αναβάθμιση: ",
  "item.minecraft.sniffer_spawn_egg": "Αβγό Γέννησης Οσφρητή",
  "item.minecraft.snort_pottery_shard": "Θραύσμα Αγγειοπλαστικής Όσφρησης",
  "item.minecraft.snort_pottery_sherd": "Θραύσμα Αγγειοπλαστικής Όσφρησης",
  "item.minecraft.snout_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Μουσούδας",
  "item.minecraft.snow_golem_spawn_egg": "Αβγό Γέννησης Γκόλεμ Χιονιού",
  "item.minecraft.snowball": "Χιονόμπαλα",
  "item.minecraft.spectral_arrow": "Λαμπερό Βέλος",
  "item.minecraft.spider_eye": "Μάτι Αράχνης",
  "item.minecraft.spider_spawn_egg": "Αβγό Γέννησης Αράχνης",
  "item.minecraft.spire_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Κορυφής",
  "item.minecraft.splash_potion": "Φίλτρο Πιτσιλιάς",
  "item.minecraft.splash_potion.effect.awkward": "Παράξενο Φίλτρο Πιτσιλιάς",
  "item.minecraft.splash_potion.effect.empty": "Μη Κατασκευάσιμο Φίλτρο Πιτσιλιάς",
  "item.minecraft.splash_potion.effect.fire_resistance": "Φίλτρο Πιτσιλιάς Αντίστασης Φωτιάς",
  "item.minecraft.splash_potion.effect.harming": "Φίλτρο Πιτσιλιάς Βλάβης",
  "item.minecraft.splash_potion.effect.healing": "Φίλτρο Πιτσιλιάς Θεραπείας",
  "item.minecraft.splash_potion.effect.infested": "Φίλτρο Πιτσιλιάς Μόλυνσης",
  "item.minecraft.splash_potion.effect.invisibility": "Φίλτρο Πιτσιλιάς Αορατότητας",
  "item.minecraft.splash_potion.effect.leaping": "Φίλτρο Πιτσιλιάς Άλματος",
  "item.minecraft.splash_potion.effect.levitation": "Φίλτρο Πιτσιλιάς Ανύψωσης",
  "item.minecraft.splash_potion.effect.luck": "Φίλτρο Πιτσιλιάς Τύχης",
  "item.minecraft.splash_potion.effect.mundane": "Κοινό Φίλτρο Πιτσιλιάς",
  "item.minecraft.splash_potion.effect.night_vision": "Φίλτρο Πιτσιλιάς Νυχτερινης Όρασης",
  "item.minecraft.splash_potion.effect.oozing": "Φίλτρο Πιτσιλιάς Γλιτσοροής",
  "item.minecraft.splash_potion.effect.poison": "Φίλτρο Πιτσιλιάς Δηλητηρίου",
  "item.minecraft.splash_potion.effect.regeneration": "Φίλτρο Πιτσιλιάς Αναζωογόνησης",
  "item.minecraft.splash_potion.effect.slow_falling": "Φίλτρο Πιτσιλιάς Αργής Πτώσης",
  "item.minecraft.splash_potion.effect.slowness": "Φίλτρο Πιτσιλιάς Βραδύτητας",
  "item.minecraft.splash_potion.effect.strength": "Φίλτρο Πιτσιλιάς Ισχύος",
  "item.minecraft.splash_potion.effect.swiftness": "Φίλτρο Πιτσιλιάς Ταχύτητας",
  "item.minecraft.splash_potion.effect.thick": "Πηχτό Φίλτρο Πιτσιλιάς",
  "item.minecraft.splash_potion.effect.turtle_master": "Φίλτρο Πιτσιλιάς του Αφέντη των Χελώνων",
  "item.minecraft.splash_potion.effect.water": "Μπουκάλι Πιτσιλιάς Νερού",
  "item.minecraft.splash_potion.effect.water_breathing": "Φίλτρο Πιτσιλιάς Υποβρύχιας Αναπνοής",
  "item.minecraft.splash_potion.effect.weakness": "Φίλτρο Πιτσιλιάς Αδυναμίας",
  "item.minecraft.splash_potion.effect.weaving": "Φίλτρο Πιτσιλιάς Πλεξίματος",
  "item.minecraft.splash_potion.effect.wind_charged": "Φίλτρο Πιτσιλιάς Ανεμοφορίας",
  "item.minecraft.spruce_boat": "Βάρκα Ελάτου",
  "item.minecraft.spruce_chest_boat": "Βάρκα Ελάτου με Σεντούκι",
  "item.minecraft.spyglass": "Μονοκυάλι",
  "item.minecraft.squid_spawn_egg": "Αβγό Γέννησης Καλαμαριού",
  "item.minecraft.stick": "Ξυλάκι",
  "item.minecraft.stone_axe": "Πέτρινο Τσεκούρι",
  "item.minecraft.stone_hoe": "Πέτρινη Τσάπα",
  "item.minecraft.stone_pickaxe": "Πέτρινη Αξίνα",
  "item.minecraft.stone_shovel": "Πέτρινο Φτυάρι",
  "item.minecraft.stone_spear": "Πέτρινο Δόρυ",
  "item.minecraft.stone_sword": "Πέτρινο Σπαθί",
  "item.minecraft.stray_spawn_egg": "Αβγό Γέννησης Περιπλανώμενου",
  "item.minecraft.strider_spawn_egg": "Αβγό Γέννησης Δρασκελιστή",
  "item.minecraft.string": "Νήμα",
  "item.minecraft.sugar": "Ζάχαρη",
  "item.minecraft.suspicious_stew": "Ύποπτο Στιφάδο",
  "item.minecraft.sweet_berries": "Γλυκά Μούρα",
  "item.minecraft.tadpole_bucket": "Κουβάς με Γυρίνο",
  "item.minecraft.tadpole_spawn_egg": "Αβγό Γέννησης Γυρίνου",
  "item.minecraft.tide_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Παλίρροιας",
  "item.minecraft.tipped_arrow": "Εμποτισμένο Βέλος",
  "item.minecraft.tipped_arrow.effect.awkward": "Εμποτισμένο Βέλος",
  "item.minecraft.tipped_arrow.effect.empty": "Μη Κατασκευάσιμο Εμποτισμένο Βέλος",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Βέλος Αντίστασης Φωτιάς",
  "item.minecraft.tipped_arrow.effect.harming": "Βέλος Βλάβης",
  "item.minecraft.tipped_arrow.effect.healing": "Βέλος Θεραπείας",
  "item.minecraft.tipped_arrow.effect.infested": "Βέλος Μόλυνσης",
  "item.minecraft.tipped_arrow.effect.invisibility": "Βέλος Αορατότητας",
  "item.minecraft.tipped_arrow.effect.leaping": "Βέλος Άλματος",
  "item.minecraft.tipped_arrow.effect.levitation": "Βέλος Ανύψωσης",
  "item.minecraft.tipped_arrow.effect.luck": "Βέλος Τύχης",
  "item.minecraft.tipped_arrow.effect.mundane": "Εμποτισμένο Βέλος",
  "item.minecraft.tipped_arrow.effect.night_vision": "Βέλος Νυχτερινής Όρασης",
  "item.minecraft.tipped_arrow.effect.oozing": "Βέλος Γλιτσοροής",
  "item.minecraft.tipped_arrow.effect.poison": "Βέλος Δηλητηρίου",
  "item.minecraft.tipped_arrow.effect.regeneration": "Βέλος Αναζωογόνησης",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Βέλος Αργής Πτώσης",
  "item.minecraft.tipped_arrow.effect.slowness": "Βέλος Βραδύτητας",
  "item.minecraft.tipped_arrow.effect.strength": "Βέλος Ισχύος",
  "item.minecraft.tipped_arrow.effect.swiftness": "Βέλος Ταχύτητας",
  "item.minecraft.tipped_arrow.effect.thick": "Εμποτισμένο Βέλος",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Βέλος του Αφέντη των Χελώνων",
  "item.minecraft.tipped_arrow.effect.water": "Βέλος Πιτσιλίσματος",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Βέλος Υποβρύχιας Αναπνοής",
  "item.minecraft.tipped_arrow.effect.weakness": "Βέλος Αδυναμίας",
  "item.minecraft.tipped_arrow.effect.weaving": "Βέλος Πλεξίματος",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Βέλος Ανεμοφορίας",
  "item.minecraft.tnt_minecart": "Βαγονέτο με TNT",
  "item.minecraft.torchflower_seeds": "Σπόροι Πυρσάνθου",
  "item.minecraft.totem_of_undying": "Τοτέμ της Αθανασίας",
  "item.minecraft.trader_llama_spawn_egg": "Αβγό Γέννησης Λάμα Εμπόρου",
  "item.minecraft.trial_key": "Κλειδί Δοκιμασίας",
  "item.minecraft.trident": "Τρίαινα",
  "item.minecraft.tropical_fish": "Τροπικό Ψάρι",
  "item.minecraft.tropical_fish_bucket": "Κουβάς με Τροπικό Ψάρι",
  "item.minecraft.tropical_fish_spawn_egg": "Αβγό Γέννησης Τροπικού Ψαριού",
  "item.minecraft.turtle_helmet": "Κέλυφος Χελώνας",
  "item.minecraft.turtle_scute": "Φολίδα Χελώνας",
  "item.minecraft.turtle_spawn_egg": "Αβγό Γέννησης Χελώνας",
  "item.minecraft.vex_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Διαταράκτη",
  "item.minecraft.vex_spawn_egg": "Αβγό Γέννησης Διαταράκτη",
  "item.minecraft.villager_spawn_egg": "Αβγό Γέννησης Χωρικού",
  "item.minecraft.vindicator_spawn_egg": "Αβγό Γέννησης Εξιλεωτή",
  "item.minecraft.wandering_trader_spawn_egg": "Αβγό Γέννησης Περιπλανώμενου Εμπόρου",
  "item.minecraft.ward_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Φύλακα",
  "item.minecraft.warden_spawn_egg": "Αβγό Γέννησης Φύλακα",
  "item.minecraft.warped_fungus_on_a_stick": "Στρεβλωμένος Μύκητας σε Ξυλάκι",
  "item.minecraft.water_bucket": "Κουβάς Νερού",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Οδηγού",
  "item.minecraft.wheat": "Σιτάρι",
  "item.minecraft.wheat_seeds": "Σπόροι Σιταριού",
  "item.minecraft.white_bundle": "Λευκό Δέμα",
  "item.minecraft.white_dye": "Λευκή Βαφή",
  "item.minecraft.white_harness": "Λευκή Σαγή",
  "item.minecraft.wild_armor_trim_smithing_template": "Πρότυπο Μεταλλουργίας",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Επένδυση Πανοπλίας Ζούγκλας",
  "item.minecraft.wind_charge": "Φορτίο Ανέμου",
  "item.minecraft.witch_spawn_egg": "Αβγό Γέννησης Μάγισσας",
  "item.minecraft.wither_skeleton_spawn_egg": "Αβγό Γέννησης Σκελετού Ουίδερ",
  "item.minecraft.wither_spawn_egg": "Αβγό Γέννησης Ουίδερ",
  "item.minecraft.wolf_armor": "Πανοπλία Λύκου",
  "item.minecraft.wolf_spawn_egg": "Αβγό Γέννησης Λύκου",
  "item.minecraft.wooden_axe": "Ξύλινο Τσεκούρι",
  "item.minecraft.wooden_hoe": "Ξύλινη Τσάπα",
  "item.minecraft.wooden_pickaxe": "Ξύλινη Αξίνα",
  "item.minecraft.wooden_shovel": "Ξύλινο Φτυάρι",
  "item.minecraft.wooden_spear": "Ξύλινο Δόρυ",
  "item.minecraft.wooden_sword": "Ξύλινο Σπαθί",
  "item.minecraft.writable_book": "Βιβλίο και Πένα",
  "item.minecraft.written_book": "Γραμμένο Βιβλίο",
  "item.minecraft.yellow_bundle": "Κίτρινο Δέμα",
  "item.minecraft.yellow_dye": "Κίτρινη Βαφή",
  "item.minecraft.yellow_harness": "Κίτρινη Σαγή",
  "item.minecraft.zoglin_spawn_egg": "Αβγό Γέννησης Ζόγκλιν",
  "item.minecraft.zombie_horse_spawn_egg": "Αβγό Γέννησης Αλόγου Ζόμπι",
  "item.minecraft.zombie_nautilus_spawn_egg": "Αβγό Γέννησης Ναυτίλου Ζόμπι",
  "item.minecraft.zombie_spawn_egg": "Αβγό Γέννησης Ζόμπι",
  "item.minecraft.zombie_villager_spawn_egg": "Αβγό Γέννησης Χωρικού Ζόμπι",
  "item.minecraft.zombified_piglin_spawn_egg": "Αβγό Γέννησης Πίγκλιν Ζόμπι"
}
export const el_gr = items; 
